/* eslint-disable no-unused-vars */
/* eslint-disable no-template-curly-in-string */
import React, {Component} from 'react';
import ReactNotification from 'react-notifications-component';
import { Trans } from 'react-i18next';

import ShoppingCart from '../components/ShoppingCart';

import { getAnamorfisLineal, getConvUTM, getDeclinacionMagnetica } from '../service/Maths';

import Step1 from './Step1';
import Step2 from './Step2';
import Step3 from './Step3';
import Step4 from './Step4';

import Step1S from './Step1S';
import Step2S from './Step2S';

import Step1P from './Step1P';
import Step2P from './Step2P';

import Step1F from './Step1F';
import Step2F from './Step2F';

import Step1SS from './Step1SS';
import Step2SS from './Step2SS';
import Step3SS from './Step3SS';

import Dialog from '@material-ui/core/Dialog';
import DialogButton from '@material-ui/core/Button';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { createTheme } from '@material-ui/core/styles';
import { ThemeProvider } from '@material-ui/styles';

import {properties} from '../resources/properties.js';

import portada_CYAN from '../img/Fondos/img53.png';
import IMG_CARTOGRAFIA_1 from '../img/Carousel/Cartografia/img91.jpg';

import 'react-notifications-component/dist/theme.css';

declare var ol;
declare var M;
const SOLAPE_29_30 = -670258.1232371033;
const SOLAPE_30_31 = -2298.774930023602;
//const oneTransparentPixel = 'iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8Xw8AAoMBgDTD2qgAAAAASUVORK5CYII='; // OLD
const oneTransparentPixel = 'iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVQI12P4zwAAAgEBAKrChTYAAAAASUVORK5CYII=';
const lengthSideLines = 5; // Length in pixels of small coordinates lines on mapDef6 and mapDef7

const theme = createTheme({
  palette: { primary: { 500: properties.BUTTON_THEME_COLOR } },
  overrides: { MuiButton: { containedPrimary: { color: 'white' } } }
});
const themeTitle = createTheme({
  palette: { primary: { 500: properties.TITLE_THEME_COLOR } },
  overrides: { MuiDialogTitle: { root: { backgroundColor: properties.TITLE_THEME_COLOR, color: 'white' } } }
});

class DataForPrint extends Component {
  constructor(props) {
    super(props);
    let active;
    if (props && props.location && props.location.search && props.location.search.toLowerCase().split('&active=').length > 1) {
      active = props.location.search.toLowerCase().split('&active=')[1];
    } else if (props && props.location && props.location.search && props.location.search.toLowerCase().split('?active=').length > 1) {
      active = props.location.search.toLowerCase().split('?active=')[1];
    } else if (props && props.location && props.location.state && props.location.state.active) {
      active = props.location.state.active;
    } else {
      active = 0
    }
    this.savedModalFilters = {};
    this.state = {
      callback: undefined,
      showAlertModalError: false,
      showAlertModalWarning: false,
      showWarningCheckboxForMAR: false,
      idUi: null,
      estado: 1,
      isSimple: false,
      active,
      activeRow: 'firstRow',
      selectedRow: '25K',
      imgCustomPortrait: undefined,
      title: '',//properties.title,
      subtitle: '',
      author: '',
      color: '#5db3ae',
      backgroundMar: "#FFFFFF",
      activeServices: {},
      portada: portada_CYAN,
      scale: '1:25.000',
      scaleCm: '250 m)',
      previousScale: '1:25.000',
      frameColor: '#FFFFFF',
      booleanGrid: false,
      booleanCoords: false,
      checkedConditions: false,
      coordinates: []/*[[ [
        [
          -420139.68704230286, 4938690.873658016
        ], [
          -420139.68704230286, 4921762.067700004
        ], [
          -397450.0312841046, 4921762.067700004
        ], [
          -397450.0312841046, 4938690.873658016
        ], [
          -420139.68704230286, 4938690.873658016
        ]
      ], [
        [
          -401225.797049155, 4925937.9648141488,
        ], [
          -401225.797049155, 4938139.381586118,
        ], [
          -419781.21312597, 4938139.381586118,
        ], [
          -419781.21312597, 4925937.9648141488,
        ], [
          -401225.797049155, 4925937.9648141488,
        ],
      ],]]*/,
      coordinatesPoster: []/*[[ [
        [
          -420469.9937379729, 4937255.042900536
        ], [
          -420469.9937379729, 4923291.006785004
        ], [
          -397024.3917169655, 4923291.006785004
        ], [
          -397024.3917169655, 4937255.042900536
        ], [
          -420469.9937379729, 4937255.042900536
        ]
      ], [
        [
          -421105.7623887435, 4938007.525595946,
        ], [
          -421105.7623887435, 4922444.287640339,
        ], [
          -396483.95593766397, 4922444.287640339,
        ], [
          -396483.95593766397, 4938007.525595946,
        ],[
          -421105.7623887435, 4938007.525595946,
        ],
      ] ]]*/,
      center: [],
      crsText: "",
      controlModal: 1,
      orientation: 'Paisaje',
      cellDensity: '1',
      gridFrame: '',
      coordinatesFrame: '',
      previousOrientation: 'Paisaje',
      baseLayer: 'MTN',
      previousBaseLayer: 'MTN',
      image_preview: IMG_CARTOGRAFIA_1,
      image: IMG_CARTOGRAFIA_1,
      imageName: 'img91.jpg',
      carouselTabActive: 'aventura',
      zoom: 10,
      lng: 'es',
      sheets: [],
      centroidSheet: null,
      ruteServerImagenesFondos: properties.ruteServerImagenesFondos,
      ruteServerImagenesLeyendas: properties.ruteServerImagenesLeyendas,
      ruteServerImagenesEsquemas: properties.ruteServerImagenesEsquemas,
      ruteServerImagenesEscalas: properties.ruteServerImagenesEscalas,
      ruteServerImagenesComunes: properties.ruteServerImagenesComunes,
      ruteServerImagenesPortada: properties.ruteServerImagenesPortada,
      ruteServerECWS: properties.ruteServerECWS,
      varLayerDraws: '',
      numberId: 0,
      inforFeatureCoordinates: []/*[[
        [
          [
            [-400750.16685578495, 4929301.193881042],
            [-400750.16685578495, 4922697.495621919],
            [-397967.17958595307, 4922697.495621919],
            [-397967.17958595307, 4929301.193881042],
            [-400750.16685578495, 4929301.193881042]
          ]
        ],
        [
          [
            [-400750.16685578495, 4931210.669647183],
            [-400750.16685578495, 4929987.677194619],
            [-397967.17958595307, 4929987.677194619],
            [-397967.17958595307, 4931210.669647183],
            [-400750.16685578495, 4931210.669647183]
          ]
        ],
        [
          [
            [-400750.16685578495, 4938139.381586121],
            [-400750.16685578495, 4931787.798296651],
            [-397967.17958595307, 4931787.798296651],
            [-397967.17958595307, 4938139.381586121],
            [-400750.16685578495, 4938139.381586121]
          ]
        ],
        [
          [
            [-419781.21312597, 4925525.665668471],
            [-419781.21312597, 4922697.495621919],
            [-410887.245546965, 4922697.495621919],
            [-410887.245546965, 4925525.665668471],
            [-419781.21312597, 4925525.665668471]
          ]
        ],
        [
          [
            [-409664.25309440214, 4925525.665668471],
            [-409664.25309440214, 4922697.495621919],
            [-401225.797049155, 4922697.495621919],
            [-401225.797049155, 4925525.665668471],
            [-409664.25309440214, 4925525.665668471]
          ]
        ]
      ]]*/
    };
  }

  setModal = (mapa, state) => {
    //let features25;let features50;let featuresPNOA;//let checkMar;
    let usedLayerName;
    if (state.seleccionadoProductoSeries === 'Foto') {
      usedLayerName = 'capaHojaPNOA';
    } else { //if (state.active <= 7) { state.seleccionadoProductoSeries === 'Elaborado' || state.seleccionadoProductoSeries === 'Poster'
      if (state.activeRow === 'firstRow') {
        usedLayerName = 'capaJson';
      } else if (state.activeRow === 'secondRow') {
        usedLayerName = 'capaJson50';
      }
    }
    const layerUsed = mapa.getLayers().find(l => l.name === usedLayerName);
    if(!this.savedModalFilters[usedLayerName]){
      const source = layerUsed.getImpl().getOL3Layer().getSource();
      if (source) {
        const arrayMFeatures = source.getFeatures().map(olFeature => M.impl.Feature.olFeature2Facade(olFeature));
        this.savedModalFilters[usedLayerName] = M.filter.spatial.INTERSECT(arrayMFeatures);//const filterCentroid
      } else { // Necesario esperar a tener source presente.
        layerUsed.getImpl().getOL3Layer().once('sourceready',this.setModal.bind(this, mapa, state));
        return false;
      } 
    }
    const auxPlugin = mapa.getPlugins().find(p => p.name === 'Mapaalacarta');
    const auxCountHojas = auxPlugin.getCountHojas();
    let coordinatesArray = [];
    if(auxCountHojas<2){
      coordinatesArray.push(auxPlugin.getCoordinates()[1]);
    } else {
      for(let k = 0; k<auxCountHojas; k++){
        coordinatesArray.push(auxPlugin.getCoordinates(k)[1]);
      }
    }
    const currentFocus = auxPlugin.getFocus();
    let stopForEach = false;
    coordinatesArray.forEach((coordinates, index) => {
      if (stopForEach){return;}
      let xmax = coordinates[1][0];
      let ymax = coordinates[3][1];
      let xmin = coordinates[3][0];
      let ymin = coordinates[1][1];
      //let centerX = (xmax + xmin) / 2;let centerY = (ymax + ymin) / 2;//let center = [centerX, centerY];
      let centroid = new M.Feature("frameCentroid", {
        "type": "Feature","id": "frameCentroid",
        "geometry": {
          "type": "Point","coordinates": [(xmax + xmin) / 2, (ymax + ymin) / 2]
        },
        "properties": {"nombre": "frameCentroid"}
      });

      if (!this.savedModalFilters[usedLayerName].getFunctionFilter()(centroid,undefined)) {
        stopForEach = true;
        this.setState({showAlertModalError: true, estado: 0});
      } else if (currentFocus === index){// intersect 4 corners. "Missing geographic information"
        let corner1 = new M.Feature("corner1", {
          "type": "Feature","id": "frameCentroid1",
          "geometry": {
            "type": "Point","coordinates": coordinates[0]
          },
          "properties": {"nombre": "frameCentroid1"}
        });
        let noEmptyCorner = this.savedModalFilters[usedLayerName].getFunctionFilter()(corner1,undefined);

        if(noEmptyCorner){
          let corner2 = new M.Feature("corner2", {
            "type": "Feature","id": "frameCentroid2",
            "geometry": {
              "type": "Point","coordinates": coordinates[1]
            },
            "properties": {"nombre": "frameCentroid2"}
          });
          noEmptyCorner = this.savedModalFilters[usedLayerName].getFunctionFilter()(corner2,undefined);
        }

        if(noEmptyCorner){
          let corner3 = new M.Feature("corner3", {
            "type": "Feature","id": "frameCentroid3",
            "geometry": {
              "type": "Point","coordinates": coordinates[2]
            },
            "properties": {"nombre": "frameCentroid3"}
          });
          noEmptyCorner = this.savedModalFilters[usedLayerName].getFunctionFilter()(corner3,undefined);
        }

        if(noEmptyCorner){
          let corner4 = new M.Feature("corner4", {
            "type": "Feature","id": "frameCentroid4",
            "geometry": {
              "type": "Point","coordinates": coordinates[3]
            },
            "properties": {"nombre": "frameCentroid4"}
          });
          noEmptyCorner = this.savedModalFilters[usedLayerName].getFunctionFilter()(corner4,undefined);
        }

        if (!noEmptyCorner) {//CHECK FOR "MAR" STATE
          const testFeatureMar = new M.Feature("TestMAR", {
            "type": "Feature","id": "TestMAR",
            "geometry": {
              "type": "Polygon",
              "coordinates": [[[xmax,ymax],[xmax,ymin],[xmin,ymin],[xmin,ymax],[xmax,ymax]]]
            },
            "properties": {"nombre": "TestMAR"}
          });
          const filterFunction = M.filter.spatial.INTERSECT(testFeatureMar).getFunctionFilter();
          const foundMARFeature = layerUsed.getFeatures().find((f,index) => f.impl_.olFeature_.values_.MAR && filterFunction(f,index));
          if(foundMARFeature){
            stopForEach = true;
            this.setState({showAlertModalWarning: true, showWarningCheckboxForMAR :true, controlModal: 1, estado: 1});
          }else{
            stopForEach = true;
            this.setState({showAlertModalWarning: true, showWarningCheckboxForMAR :false, backgroundMar: "#FFFFFF", controlModal: 1, estado: 1});
          }
        }
      }
    });
    if(!stopForEach){
      this.setState({controlModal: 1, estado: 1});
    }
  }


  setStateGlobalSteps = (state) => {
    let layerSheets = [];
    let tempMapLayers = state.mapa.getLayers();

    for (let j = 0; j < tempMapLayers.length; j++) {
      if (state.seleccionadoProductoSeries === 'Foto') {
        if (tempMapLayers[j].name === "capaHojaPNOA") {
          layerSheets = tempMapLayers[j].getImpl().getOL3Layer();
        }
      } else { //if (state.active <= 7) { state.seleccionadoProductoSeries === 'Elaborado' || state.seleccionadoProductoSeries === 'Poster'
        if (tempMapLayers[j].name === 'capaJson' && (state.scale === "1:2.500" || state.scale === "1:5.000" || state.scale === "1:10.000" || state.scale === "1:25.000" || state.scale === "1:20.000" || state.scale === "1:30.000")) {
          layerSheets = tempMapLayers[j].getImpl().getOL3Layer();
        } else if (tempMapLayers[j].name === 'capaJson50' && (state.scale === "1:50.000" || state.scale === "1:40.000" || state.scale === "1:60.000")) {
          layerSheets = tempMapLayers[j].getImpl().getOL3Layer();
        }
      }
    }

    let frameLayer = state.mapa.getMapImpl().getLayers().getArray().find(layer => layer.get('id') === 'frame_layer');//Vector_layer de Mapaalacarta
    let frameFeatures = frameLayer.getSource().getFeatures().filter(feature => feature.get('id').startsWith('frame_feature'));
    let inforFeatures = frameLayer.getSource().getFeatures().filter(feature => feature.get('id').startsWith('infor_feature'));

    //Chrome wrong order fix
    const sortFunct = (a, b)=>{
      if (a.values_.id < b.values_.id) {return -1;}
      else if (a.values_.id > b.values_.id) {return 1;}
      return 0;// a.values_.id == b.values_.id
    };
    frameFeatures.sort(sortFunct);
    inforFeatures.sort(sortFunct);
    //Chrome wrong order fix

    state.inforFeatureCoordinates = inforFeatures.map(f=>f.getGeometry().getCoordinates());

    //let xmax;let ymax;let xmin;let ymin;
    //if (state.active > 5) { state.seleccionadoProductoSeries === 'Foto' || state.seleccionadoProductoSeries === 'Poster'
    const auxName = state.seleccionadoProductoSeries === 'Elaborado' ? 'coordinates' : 'coordinatesPoster';
    state[auxName] = frameFeatures.map(f=>f.getGeometry().getCoordinates());
    //xmax = state[auxName][0][1][2][0];
    //ymax = state[auxName][0][1][0][1];
    //xmin = state[auxName][0][1][0][0];
    //ymin = state[auxName][0][1][2][1];
    this.insideCoordinates = state[auxName].map(c=>{
      return[c[1][0][0], c[1][2][1], c[1][2][0], c[1][0][1]]; // xmin, ymin, xmax, ymax
    });

    //----------------------ADD USED SHEETS TO STATE
    let olLayerToMLayer = new M.layer.GeoJSON({name: 'emptyLayer'});
    let olLayerToMLayerCentroid = new M.layer.GeoJSON({name: 'emptyCentroidLayer'});

    let featuresOlLayer = layerSheets.getSource().getFeatures();

    const arrayMFeatures = featuresOlLayer.map(olFeature => M.impl.Feature.olFeature2Facade(olFeature));

    if (olLayerToMLayer.impl_.features_.length === 0) {
      olLayerToMLayer.impl_.features_ = arrayMFeatures;
      olLayerToMLayer.impl_.redraw();
    } else {
      olLayerToMLayer.addFeatures(arrayMFeatures);
    }

    if (olLayerToMLayerCentroid.impl_.features_.length === 0) {
      olLayerToMLayerCentroid.impl_.features_ = arrayMFeatures;
      olLayerToMLayerCentroid.impl_.redraw();
    } else {
      olLayerToMLayerCentroid.addFeatures(arrayMFeatures);
    }

    let scaleTransformed;
    switch (state.scale) {
      case '1:2.500':
        scaleTransformed = 2500;
        break;
      case '1:5.000':
        scaleTransformed = 5000;
        break;
      case '1:10.000':
        scaleTransformed = 10000;
        break;
      case '1:25.000':
        scaleTransformed = 25000;
        break;
      case '1:20.000':
        scaleTransformed = 20000;
        break;
      case '1:30.000':
        scaleTransformed = 30000;
        break;
      case '1:40.000':
        scaleTransformed = 40000;
        break;
      case '1:50.000':
        scaleTransformed = 50000;
        break;
      case '1:60.000':
        scaleTransformed = 60000;
        break;
      default:
        scaleTransformed = 2500;
    }

    //CENTROIDES
    state.center = [];
    const centroidFilters = this.insideCoordinates.map(e => {
      // xmin == e[0], ymin == e[1], xmax == e[2], ymax == e[3]
      let center = [(e[2] + e[0]) / 2, (e[3] + e[1]) / 2];
      state.center.push(center);

      let centroid = new M.Feature("frameCentroid", {
        "type": "Feature",
        "id": "frameCentroid",
        "geometry": {
          "type": "Point",
          "coordinates": center
        },
        "properties": {
          "nombre": "frameCentroid"
        }
      });

      return M.filter.spatial.INTERSECT(centroid);
    })

    const allCentroidSheets = [];
    centroidFilters.forEach(cf => {
      olLayerToMLayerCentroid.setFilter(cf);
      if(olLayerToMLayerCentroid.getFeatures()[0]){//avoid undefined for next operations
        allCentroidSheets.push(olLayerToMLayerCentroid.getFeatures()[0]);
      }
    });
    state.centroidSheet = allCentroidSheets;
    //proj intermedia para calcular centro/esquinas y luego vuelve a 4326/3857. No determina la proyección final.
    const projectionOptions = allCentroidSheets.map((s,i) => {
      let auxPr = '258' + s.getAttribute('HUSO');
      let xy_center = state.center[i];
      let lProj = 'EPSG:' + auxPr;
      return {labelProjection: lProj, scaledCenter: ol.proj.transform([
        xy_center[0], xy_center[1]
      ], 'EPSG:3857', lProj)}
    });
    //const projection = '258' + state.centroidSheet.getAttribute('HUSO');
    //const xy_center = state.center;
    //const labelProjection = 'EPSG:' + projection;
    /*const scaledCenter = ol.proj.transform([
      xy_center[0], xy_center[1]
    ], 'EPSG:3857', labelProjection);*/
    // ------------------------------------
    let coordBotLeft;
    let coordTopLeft;
    let coordBotRight;
    let coordTopRight;
    /*let xCoordTopLeft;
    let yCoordBotLeft;
    let xCoordTopRight;
    let yCoordTopRight;
    let xCoordBotLeft;
    let yCoordTopLeft;
    let xCoordBotRight;
    let yCoordBotRight;*/
    let auxScale5 = scaleTransformed / 5;//Factor de escala (scaleTransformed/5000)*1000, como esta en kilometros le multiplicamos 1000 para que concuerde con las coordenadas UTM
    let aux0 = 0;
    let aux1 = 0;

    if (state.orientation === 'Paisaje' && state.seleccionadoProductoSeries === 'Elaborado') { //if (state.orientation === 'Paisaje' && state.active < 6) {
      //Cogemos la distancia (en km) que hay desde el centro al lado correspondiente, lo multiplicamos con el factor de escala
      aux0 = properties.PROPORTION_PIXEL_DISTANCE_LONGSIDE * auxScale5;
      aux1 = properties.PROPORTION_PIXEL_DISTANCE_SHORTSIDE * auxScale5;
    } else if (state.orientation === 'Retrato' && state.seleccionadoProductoSeries === 'Elaborado') {//} else if (state.orientation === 'Retrato' && state.active < 6) {
      aux0 = properties.PROPORTION_PIXEL_DISTANCE_SHORTSIDE_VERTICAL * auxScale5;
      aux1 = properties.PROPORTION_PIXEL_DISTANCE_LONGSIDE_VERTICAL * auxScale5;
    } else if (state.orientation === 'Paisaje') {
      if (state.posterLegend) {// poster_L
        aux0 = properties.PROPORTION_PIXEL_DISTANCE_LONGSIDE_POSTER_HORIZONTAL_LEYENDA * auxScale5;
        aux1 = properties.PROPORTION_PIXEL_DISTANCE_SHORTSIDE_POSTER_HORIZONTAL_LEYENDA * auxScale5;
      } else {
        aux0 = properties.PROPORTION_PIXEL_DISTANCE_LONGSIDE_POSTER_HORIZONTAL * auxScale5;
        aux1 = properties.PROPORTION_PIXEL_DISTANCE_SHORTSIDE_POSTER_HORIZONTAL * auxScale5;
      }
    } else if (state.orientation === 'Retrato') {
      if(state.posterLegend){// posterPortrait_L
        aux0 = properties.PROPORTION_PIXEL_DISTANCE_SHORTSIDE_POSTER_VERTICAL_LEYENDA * auxScale5;
        aux1 = properties.PROPORTION_PIXEL_DISTANCE_LONGSIDE_POSTER_VERTICAL_LEYENDA * auxScale5;
      } else {
        aux0 = properties.PROPORTION_PIXEL_DISTANCE_SHORTSIDE_POSTER_VERTICAL * auxScale5;
        aux1 = properties.PROPORTION_PIXEL_DISTANCE_LONGSIDE_POSTER_VERTICAL * auxScale5;
      }
    }
    state.coordBotLeft = [];state.coordTopLeft = [];state.coordBotRight = [];state.coordTopRight = [];
    state.sheets = [];
    projectionOptions.forEach((proj, index) => {
      let leftCorner = [
        proj.scaledCenter[0] - aux0,
        proj.scaledCenter[1] - aux1
      ];
      let rightCorner = [
        proj.scaledCenter[0] + aux0,
        proj.scaledCenter[1] + aux1
      ];
      coordBotLeft = ol.proj.transform(leftCorner, proj.labelProjection, 'EPSG:4326');
      coordTopLeft = ol.proj.transform([leftCorner[0], rightCorner[1]], proj.labelProjection, 'EPSG:4326');
      coordTopRight = ol.proj.transform(rightCorner, proj.labelProjection, 'EPSG:4326');
      coordBotRight = ol.proj.transform([rightCorner[0], leftCorner[1]], proj.labelProjection, 'EPSG:4326');
      /*xCoordBotLeft = this.formatCornersCoordinatesMethod(this.converterDecimalToDMS(coordBotLeft[0]));
      yCoordBotLeft = this.formatCornersCoordinatesMethod(this.converterDecimalToDMS(coordBotLeft[1]));
      xCoordTopRight = this.formatCornersCoordinatesMethod(this.converterDecimalToDMS(coordTopRight[0]));
      yCoordTopRight = this.formatCornersCoordinatesMethod(this.converterDecimalToDMS(coordTopRight[1]));
      xCoordTopLeft = this.formatCornersCoordinatesMethod(this.converterDecimalToDMS(coordTopLeft[0]));
      yCoordTopLeft = this.formatCornersCoordinatesMethod(this.converterDecimalToDMS(coordTopLeft[1]));
      xCoordBotRight = this.formatCornersCoordinatesMethod(this.converterDecimalToDMS(coordBotRight[0]));
      yCoordBotRight = this.formatCornersCoordinatesMethod(this.converterDecimalToDMS(coordBotRight[1]));*/
      state.coordBotLeft.push(ol.proj.transform([coordBotLeft[0], coordBotLeft[1]], 'EPSG:4326', 'EPSG:3857'));
      state.coordTopLeft.push(ol.proj.transform([coordTopLeft[0], coordTopLeft[1]], 'EPSG:4326', 'EPSG:3857'));
      state.coordBotRight.push(ol.proj.transform([coordBotRight[0], coordBotRight[1]], 'EPSG:4326', 'EPSG:3857'));
      state.coordTopRight.push(ol.proj.transform([coordTopRight[0], coordTopRight[1]], 'EPSG:4326', 'EPSG:3857'));

      // CREATED FAKE FEATURE TO COMPARE
      let miFeature = new M.Feature("featureCoordinates", {
        "type": "Feature",
        "id": "coordinatesFeature",
        "geometry": {
          "type": "Polygon",
          "coordinates": [
            [state.coordTopRight[index], state.coordBotRight[index], state.coordBotLeft[index], state.coordTopLeft[index], state.coordTopRight[index]]
          ]
        },
        "properties": {
          "nombre": "featureCoordinates"
        }
      });

      let filterCustomFeature = M.filter.spatial.INTERSECT(miFeature);
      olLayerToMLayer.setFilter(filterCustomFeature);

      // Todas las huellas que intersectan el marco
      const intersectedSheets = olLayerToMLayer.getFeatures();

      if (state.seleccionadoProductoSeries === 'Foto') { //si estamos en la foto
        //guardamos el bbox del marco
        const bboxCorners = [
          state.coordTopRight[index],
          state.coordBotRight[index],
          state.coordBotLeft[index],
          state.coordTopLeft[index]
        ];

        // buscamos una OV que cubra completamente el bbox del mapa. Devuelve
        // una hoja OV, si existe alguna que cubre completamente el marco
        // undefined, si no existe ninguna
        const fullOvSheet = intersectedSheets.find((sheet) => {
          if (sheet.getAttribute('TIPO') !== 'OV') {
            return false;
          }
          //obtenemos la geometría de la huella OV
          const olGeom = sheet.getImpl().getOLFeature().getGeometry();
          if (!olGeom) {
            return false;
          }

          // Si las 4 esquinas del marco caen dentro de la huella OV,
          // consideramos que el mapa queda completamente dentro de esa OV
          return bboxCorners.every((corner) => olGeom.intersectsCoordinate(corner));
        });

        if (fullOvSheet) {
          // Solo cargar la OV
          state.sheets.push([fullOvSheet]);
        } else {
          // Cargar todas las hojas que intersectan el marco,
          // ordenando primero las OV y después las MA
          // para que las OV tengan prioridad de representación.
          const orderedSheets = [...intersectedSheets].sort((a, b) => {
            const priorityA = a.getAttribute('TIPO') === 'OV' ? 0 : 1;
            const priorityB = b.getAttribute('TIPO') === 'OV' ? 0 : 1;
            return priorityA - priorityB;
          });
          state.sheets.push(orderedSheets);
        }
        
      } else {
        state.sheets.push(intersectedSheets);
      }
    });

    //TO ARRAY CONVERTED state.centroidSheet state.center state.sheets state.coordBotLeft, state.coordTopLeft, state.coordBotRight, state.coordTopRight;

    this.setStateGlobal(state);
  }

  setStateGlobal = (state) => {
    this.setState({
      image_preview: state.image_preview,
      active: state.active,
      numberId: !state.isSimple && window.mapJs && window.mapJs.getPlugins().find(p => p.name === "EditionTools")
        ? window.mapJs.getPlugins().find(p => p.name === "EditionTools").getNumberOfIdFeature()
        : 0,
      title: state.title,
      eventKey: state.eventKey,
      subtitle: state.subtitle,
      author: state.author,
      imgCustomPortrait: state.imgCustomPortrait,
      color: state.color,
      scale: state.scale,
      coordinates: state.coordinates,
      center: state.center,
      orientation: state.orientation,
      cellDensity: state.cellDensity,
      image: state.image,
      carouselTabActive: state.carouselTabActive,
      mapa: state.mapa,
      idUi: state.idUi,
      zoom: state.zoom,
      scaleCm: state.scaleCm,
      sheets: state.sheets,
      centroidSheet: state.centroidSheet,
      imageName: state.imageName,
      inforFeatureCoordinates: state.inforFeatureCoordinates,
      crsText: state.crsText,
      gridFrame: state.gridFrame,
      coordinatesFrame: state.coordinatesFrame,
      isSimple: state.isSimple
    });
  }

  getAnamorfis(huso, centro) {
    const transformedCenter = ol.proj.transform(centro, 'EPSG:3857', 'EPSG:4326');
    return getAnamorfisLineal(transformedCenter[0], transformedCenter[1], huso);
  }

  toggleBackground(){
    let aux = this.getState();
    if (aux.backgroundMar === "#FFFFFF") {
      this.setState({backgroundMar: properties.MAR_COLOR});
    }else{
      this.setState({backgroundMar: "#FFFFFF"});
    }
  }

  async getDeclinacion(huso, centro, seriesNumber = undefined) {
    const transformedCenter = ol.proj.transform(centro, 'EPSG:3857', 'EPSG:4326');
    const datosMatemáticos = getConvUTM(transformedCenter[0], transformedCenter[1], huso);
    const convergenciaUTM = datosMatemáticos[1]; // OMEGA
    const amorfisLineal = datosMatemáticos[0];
    let auxPromise = getDeclinacionMagnetica(transformedCenter[0], transformedCenter[1]).then((response) => {
      const resDecLon = document.createElement('html');
      let trueResponse;
      let padre;
      let declinacionMagnetica;
      let declinacionAnual;
      let strAux;

      if (huso === "28") {
        declinacionMagnetica = "undefined";
        declinacionAnual = "undefined";
      } else {
        trueResponse = response.data.replace('id="resDecLon"', 'class="resDecLon"');
        resDecLon.innerHTML = trueResponse;

        try {
          padre = resDecLon.getElementsByClassName('resDecLon')[0].parentElement;
          strAux = padre.innerText.replace("[", ""); // DELTA
          strAux = strAux.replace("]", "");
          declinacionMagnetica = strAux;
          declinacionAnual = padre.parentElement.parentElement.children[padre.parentElement.parentElement.children.length - 1].children[1].innerText.split(' ');

        } catch  {
          declinacionMagnetica = "undefined";
          declinacionAnual = "undefined";
        }

      }
      let today = new Date();
      const dd = String(today.getDate());
      const mm = String(today.getMonth() + 1);
      let mesDelAnyo;
      switch (mm) {
        case "1":
          mesDelAnyo = 'enero';
          break;
        case '2':
          mesDelAnyo = 'febrero';
          break;
        case '3':
          mesDelAnyo = 'marzo';
          break;
        case '4':
          mesDelAnyo = 'abril';
          break;
        case '5':
          mesDelAnyo = 'mayo';
          break;
        case '6':
          mesDelAnyo = 'junio';
          break;
        case '7':
          mesDelAnyo = 'julio';
          break;
        case '8':
          mesDelAnyo = 'agosto';
          break;
        case '9':
          mesDelAnyo = 'septiembre';
          break;
        case '10':
          mesDelAnyo = 'octubre';
          break;
        case '11':
          mesDelAnyo = 'noviembre';
          break;
        case '12':
          mesDelAnyo = 'diciembre';
          break;
        default:
          break;
      }
      let textoDeclinacionAnual;
      if (declinacionAnual[1].includes('Oeste')) {
        textoDeclinacionAnual = "disminuye cada año " + declinacionAnual[0];
      } else {
        textoDeclinacionAnual = "aumenta cada año " + declinacionAnual[0];
      }
      const yyyy = today.getFullYear();
      const trueResultado = [];
      let resultado;
      let auxAmorfis = amorfisLineal.toString();
      auxAmorfis = auxAmorfis.substring(0, 8);
      if (declinacionAnual === "undefined" && declinacionMagnetica === "undefined") {
        resultado = "\n\n\n\n\n\n\n\nHuso " + huso + ". Convergencia de la cuadrícula        = " + convergenciaUTM + "\n\nFactor de escala = " + auxAmorfis;

      } else {
        resultado = "Valor medio de la declinación magnética para el\n\n" + dd + " de " + mesDelAnyo + " de " + yyyy + "\n\n      =" + declinacionMagnetica + "\n\nLa declinación " + textoDeclinacionAnual + "\n\nHuso " + huso + ". Convergencia de la cuadrícula        = " + convergenciaUTM + "\n\nFactor de escala = " + auxAmorfis;

      }
      trueResultado[0] = resultado;
      trueResultado[1] = declinacionMagnetica;
      trueResultado[2] = declinacionAnual;
      trueResultado[3] = convergenciaUTM;
      trueResultado[4] = auxAmorfis;
      if (seriesNumber !== undefined) {
        if (!(this.state.mathsDataCenter instanceof Array)) {
          this.state.mathsDataCenter = [];
          this.state.mathsDataCenter[seriesNumber] = trueResultado;
        } else {
          this.state.mathsDataCenter[seriesNumber] = trueResultado;
        }
      } else {
        this.state.mathsDataCenter = trueResultado;
      }
    });
    if (seriesNumber !== undefined) {
      if (!(this.state.mathsDataCenter instanceof Array)) {
        this.state.mathsDataCenter = [];
        this.state.mathsDataCenter[seriesNumber] = auxPromise;
      } else {
        this.state.mathsDataCenter[seriesNumber] = auxPromise;
      }
    } else {
      this.state.mathsDataCenter = auxPromise;
    }
  }

  conversorStateToMapfish = (state, productoAux) => {
    //let EJEMPLO_DE_MULTIPLES_MAPAS = 0;
    let producto = productoAux === 'Serie'? state.seleccionadoProductoSeries : productoAux;
    /*
    Del Active 0 al 3, son los step1,step2,step3 y step4, de "Mapa Elaborado".
    Los Actives 4 y 5, son step1S y step2S, de "Mapa Rápido". Etiquedato como Elaborado por ahora
    Los Actives 6 y 7, son step1P y step2P, de "Mapa Póster".
    Los Actives 8 y 9, son step1F y step2F, de "Mapa Foto".
    Del Active 10 al 12 son step1SS,step2SS y step3SS de "Mapa Series".
    */
    let preparedResult = state.center.map((mapfish, index) => {

    let result;
    let layout; //orientacion del mapa              +
    let logo_map; //logo del mapa
    let title; //titulo del mapa                    +
    let subtitle; //subtitulo del mapa              +
    let colorFront; //color de la portada           +
    let logo_cover; //logo de la portada
    let scale; //escala del mapa                    +
    let imageFront; //imagen portada                +
    let author; //autor del mapa                    +
    let xy_center; //centro del frame_feature       +
    let huso; //huso del centro de la hoja
    let infoCRS; //mareografo de referencia DATUM (valores de 1 a 11)
    let legend = []; //leyendas del mapa
    let sheets = []; //hojas usadas en el vector
    let ruteServerECWS = state.ruteServerECWS;
    let projection;
    let date;

    if (producto === 'Elaborado' || producto === 'Poster') {//if (state.active < 8) {
      date = state.centroidSheet[index].getAttribute('FECHA');
    } else { //Foto
      date = '***DATE***';
    }

    // PROPERTIES OF THE CENTROID
    huso = state.centroidSheet[index].getAttribute('HUSO');
    const xCenter = state.center[index][0];
    if (huso !== '28') {
      if (xCenter < SOLAPE_29_30) {
        huso = '29';
      } else if (xCenter > SOLAPE_30_31) {
        huso = '31';
      } else {
        huso = '30';
      }
    }

    // projection = (
    //   huso === '28'
    //   ? '326'
    //   : '258') + huso;
    if (huso === '28' && producto === 'Foto' && properties.PNOA_MODE === 'LOCAL') {
      projection = '4083'; // REGCAN95 UTM 28N
    } else {
      projection = (huso === '28' ? '326' : '258') + huso; //MTN Canarias en 32628, Península/Baleares en 258xx
    }
    // let num_hoja = state.centroidSheet.getAttribute('num_hoja');
    // let ccff25 = state.centroidSheet.getAttribute('CCFF25');
    // let crs = state.centroidSheet.getAttribute('CRS');
    // let escala = state.centroidSheet.getAttribute('Escala');
    // let esq_c_d = state.centroidSheet.getAttribute('Esq_C_D');
    // let mtn25_clas = state.centroidSheet.getAttribute('MTN25_CLAS');
    //let nombre_25 = state.centroidSheet.getAttribute('NOMBRE_25');
    
    //no entiendo por qué en la foto está forzando a crs=1, lo cambio para que siempre use el CRS de la hoja
    // if (producto === 'Elaborado' || producto === 'Poster') {//if (state.active <= 7) {
    //   infoCRS = state.centroidSheet[index].getAttribute('CRS');
    // } else {
    //   infoCRS = 1;
    // }
    infoCRS = state.centroidSheet[index].getAttribute('CRS');

    if (producto === 'Elaborado' || state.posterLegend) {//if (state.active < 6 || state.posterLegend) {
      this.getDeclinacion(huso, state.center[index], productoAux === 'Serie'? index : undefined);
    }

    let HUSO25 = properties.ECW25k_FOLDER_ROUTE + huso + "/";
    let HUSO50 = properties.ECW50k_FOLDER_ROUTE + huso + "/";
    let delta;
    let omega;
    if (state.orientation === 'Paisaje') {
      if(producto === 'Elaborado')//if(state.active < 6)
        if(state.verticalCartela){
          layout = 'landscape_R'
        } else layout = 'landscape';
      else if(state.posterLegend){
        layout = 'poster_L';
      }
      else
        layout = 'poster';
      delta = state.ruteServerImagenesComunes + "img198.png";
      omega = state.ruteServerImagenesComunes + "img197.png";

    } else if (state.orientation === 'Retrato') {
      if(producto === 'Elaborado'){//if(state.active < 6){
        if(state.verticalCartela){
          layout = 'portrait_R'
        } else layout = 'portrait';
      }
      else if(state.posterLegend){
        layout = 'posterPortrait_L';
      } else layout = 'posterPortrait';
      delta = state.ruteServerImagenesComunes + "img198_R.png";
      omega = state.ruteServerImagenesComunes + "img197_R.png";
    }

    //--------JSON ESTILOS
    let DPIEstilos = 300;
    let jsonEstilosPDFComma;
    let jsonEstilosPDF = [];
    let jsonEstilosImage = [];
    if (state.isSimple === false) {
      let pluginAux = state.mapa.getPlugins().find(plugin => plugin.name === "EditionTools");
      state.definedLegend=pluginAux.getLegendToSend();
      let jsonEstilosPDFOrigin = pluginAux.generateMapfishGeoJSON(state.mapa.getLayers(), "EPSG:" + projection, DPIEstilos);

      jsonEstilosPDFComma = jsonEstilosPDFOrigin.substring(0, jsonEstilosPDFOrigin.length - 1);
      if (jsonEstilosPDFComma.length > 0) {
        const jsonEstilosArray = jsonEstilosPDFComma.split('}}},');
        let index = 0;
        jsonEstilosArray.forEach((dibujo) => {
          if (index !== jsonEstilosArray.length - 1) {
            jsonEstilosPDF.push(JSON.parse(dibujo + "}}}"));
            index++;
          } else {
            const count = (dibujo.match(/base64/g) || []).length;
            if (count > 1 && dibujo.indexOf('"type": "image"') > -1) {
              const jsonImages = dibujo.split(']},');
              let indexImage = 0;
              jsonImages.forEach((image) => {
                if (indexImage !== jsonImages.length - 1) {
                  jsonEstilosImage.push(JSON.parse(image + ']}'));
                  indexImage++;
                } else {
                  jsonEstilosImage.push(JSON.parse(image));
                }
              });
            } else {
              jsonEstilosImage.push(JSON.parse(dibujo));
            }
          }
        });
      }
    }
    //-------- añadidas
    let scaleCm;
    let scaleImg;
    // let scaleImg120000;
    // let scaleImg;
    // let scaleImg130000;
    // let scaleImg140000;
    // let scaleImg150000;
    // let scaleImg160000;

    //let imgTransparent;
    // let mareografo = state.ruteServerImagenesEsquemas + 'img34.png'; 'TODO AUN POR DEFINIR';

    let labelProjection; //Projection label for GRID.
    const ProyeccionMapaUbicacionPeninsula = 'EPSG:25830';
    const ProyeccionMapaUbicacionCanarias = 'EPSG:25828';
    let scaledCenter; //center scaled to projection needed
    let scaleTransformed;
    let qrcode;
    let logoMapaALaCarta;
    let logoMapaALaCartaCorner;
    let mainImg;
    let mainImgBack;
    let imgArrow;
    let imageFrontCustom;

    //LEGENDS

    let populationCoreText = "NÚCLEOS DE POBLACIÓN";
    let populationCoreTextEnglish = "POPULATION";
    let currentsSignsText = "SIGNOS CONVENCIONALES";
    let currentsSignsTextEnglish = "LEGEND";
    let landUseText = "USOS DEL SUELO";
    let landUseTextEnglish = "LAND USE";

    //--------ecw sheets
    let baseNameSheets; //for create name of ecw sheets
    let layersSheets = []; //for create name of ecw sheets
    let layerTiffSpain = {
      "type": "geotiff",
      "url": "file:/" + state.ruteServerImagenesComunes + "img08.tif"
    };
    let layerTiffCanaryIslands = {
      "type": "geotiff",
      "url": "file:/" + state.ruteServerImagenesComunes + "img09.tif"
    };

    let dpi = 300;
    let indent = 25; // distancia de seperación entre la etiqueta y el mapa.

    //----MAP

    let mapDef1; //map that contains all layers and lines of grid
    let mapDef2; //map behind the first map that contains labels for grid (Y axis)
    let mapDef5; // Grid X axis
    let mapDef3; //minimap of Spain. Front view. For setting position
    let mapDef4; //minimap of Canary Island. Front view. For setting position

    //EXTERIOR GRID,   MARKS
    let mapDef6;
    let mapDef7;

    /*let topRightCorner;
    let topLeftCorner;
    let botLeftCorner;
    let botRightCorner;*/
    let origin; // origin point to print grid layer.
    const calSpacing = 1000 * Number(state.cellDensity);
    let spacing = [calSpacing, calSpacing]; //x,y spacing between lines of grid (normally 1km=> [1000,1000])
    let spacingA = [0, calSpacing];
    let spacingB = [calSpacing, 0];

    let spacingMap2;
    let spacingMap5;
    //-- CORNERS
    /*if (state.coordinates !== undefined && state.coordinates !== null) {
      if(state > 5){
        topRightCorner = state.coordinatesPoster[1][1];
        topLeftCorner = state.coordinatesPoster[1][2];
        botLeftCorner = state.coordinatesPoster[1][3];
        botRightCorner = state.coordinatesPoster[1][0];
      } else {
        topRightCorner = state.coordinates[1][1];
        topLeftCorner = state.coordinates[1][2];
        botLeftCorner = state.coordinates[1][3];
        botRightCorner = state.coordinates[1][0];
      }
    } else {
      topRightCorner = [0, 0];
      topLeftCorner = [0, 0];
      botLeftCorner = [0, 0];
      botRightCorner = [0, 0];
    }*/

    // PARAMETROS COMUNES HORIZONTAL-VERTICAL
    // bbox = state.coordinates[1];
    if(state.serImgC){
      subtitle = state.serImgC[index].subtitle;
      title = state.serImgC[index].title;
      colorFront = state.serImgC[index].color;
      author = state.serImgC[index].author;
    }else{
      subtitle = state.subtitle;
      title = state.title;
      colorFront = state.color;
      author = state.author;
    }

    scale = state.scale;
    xy_center = state.center[index];

    // mainImgBack = state.ruteServerImagenesFondos;

    // OBTENCIÓN DE DISTINTOS CRS EN FUNCIÓN DE LA HOJA CENTRAL.
    let codigosLegales = '';
    if(state.serImgC){
      if(state.serImgC[index].nipo || state.serImgC[index].isbn || state.serImgC[index].depositoLegal){
        codigosLegales = 'NIPO: ' + state.serImgC[index].nipo + ', ISBN: ' + state.serImgC[index].isbn + ', Depósito Legal: ' + state.serImgC[index].depositoLegal + '.\nCatálogo de publicaciones de la AGE www.cpage.mpr.gob.es. Impreso en la imprenta del Instituto Geográfico Nacional en papel ';
        if(producto === 'Elaborado' || state.posterLegend){
          codigosLegales = codigosLegales + "libre de color de acuerdo con los criterios medioambientales de la contratación pública.";
        } else {
          codigosLegales = codigosLegales + "certificado FSC®.";
        }
      }
    } else {
      if(state.nipo || state.isbn || state.depositoLegal){
        codigosLegales = 'NIPO: ' + state.nipo + ', ISBN: ' + state.isbn + ', Depósito Legal: ' + state.depositoLegal + '.\nCatálogo de publicaciones de la AGE www.cpage.mpr.gob.es. Impreso en la imprenta del Instituto Geográfico Nacional en papel ';
        if(producto === 'Elaborado' || state.posterLegend){
          codigosLegales = codigosLegales + "libre de color de acuerdo con los criterios medioambientales de la contratación pública.";
        } else {
          codigosLegales = codigosLegales + "certificado FSC®.";
        }
      }
    }

    let textoResponsabilidadOCodigosEspeciales = '';
    if(codigosLegales){
      textoResponsabilidadOCodigosEspeciales = codigosLegales;
    }else{
      if(producto === 'Poster'){
        textoResponsabilidadOCodigosEspeciales = 'El IGN no se responsabiliza de los elementos definidos por el usuario al crear su propio mapa.';
      } else if(producto === 'Foto'){
        textoResponsabilidadOCodigosEspeciales = 'El IGN no se responsabiliza de los elementos definidos por el usuario al crear su propia foto.';
      } else if(producto === 'Elaborado'){
        textoResponsabilidadOCodigosEspeciales = 'El IGN no se responsabiliza de los elementos definidos por el usuario al crear su propio mapa: título, subtítulo, fotografía de la portada e información geográfica añadida a la base cartográfica.';
      }
    }

    let crsText, crsTextLongitudes, crsTextPoster;
    let crsTextLongitudesCorto="Las longitudes están referidas al meridiano de Greenwich."; //para el PNOA
    switch (infoCRS) {
      case 1:
        crsText = "Elipsoide SGR80. Proyección U.T.M. Datum ETRS89. ";
        crsTextPoster = "Elipsoide SGR80. Proyección U.T.M. Huso " + huso + ". Datum ETRS89.";
        crsTextLongitudes = crsTextLongitudesCorto + "\nLas altitudes se refieren al nivel medio del Mediterráneo en Alicante. Mareógrafo del IGN.\n";
        break;
      case 2:
        crsText = "Elipsoide SGR80. Proyección U.T.M. Datum ETRS89. ";
        crsTextPoster = "Elipsoide SGR80. Proyección U.T.M. Huso " + huso + ". Datum ETRS89.";
        crsTextLongitudes = crsTextLongitudesCorto + "\nLas altitudes se refieren al nivel medio del Mediterráneo en Ciutadella. Mareógrafo del Gobierno Balear.\n";
        break;
      case 3:
        crsText = "Elipsoide SGR80. Proyección U.T.M. Datum ETRS89. ";
        crsTextPoster = "Elipsoide SGR80. Proyección U.T.M. Huso " + huso + ". Datum ETRS89.";
        crsTextLongitudes = crsTextLongitudesCorto + "\nLas altitudes se refieren al nivel medio del Mediterráneo en Palma de Mallorca. Mareógrafo del IEO.\n";
        break;
      case 4:
        crsText = "Elipsoide SGR80. Proyección U.T.M. Datum ETRS89. ";
        crsTextPoster = "Elipsoide SGR80. Proyección U.T.M. Huso " + huso + ". Datum ETRS89.";
        crsTextLongitudes = crsTextLongitudesCorto + "\nLas altitudes se refieren al nivel medio del Mediterráneo en el Puerto de Eivissa. Mareógrafo de Puertos del Estado.\n";
        break;
      case 5:
        crsText = "Elipsoide SGR80. Proyección U.T.M. Datum REGCAN95. ";
        crsTextPoster = "Elipsoide SGR80. Proyección U.T.M. Huso " + huso + ". Datum REGCAN95.";
        crsTextLongitudes = crsTextLongitudesCorto + "\nLas altitudes se refieren al nivel medio del Océano Atlántico en Arrecife. Mareógrafo del Instituto Español de Oceanografía.\n";
        break;
      case 6:
        crsText = "Elipsoide SGR80. Proyección U.T.M. Datum REGCAN95. ";
        crsTextPoster = "Elipsoide SGR80. Proyección U.T.M. Huso " + huso + ". Datum REGCAN95.";
        crsTextLongitudes = crsTextLongitudesCorto + "\nLas altitudes se refieren al nivel medio del Océano Atlántico en Santa Cruz de la Palma. Mareógrafo del Instituto Español de Oceanografía.\n";
        break;
      case 7:
        crsText = "Elipsoide SGR80. Proyección U.T.M. Datum REGCAN95. ";
        crsTextPoster = "Elipsoide SGR80. Proyección U.T.M. Huso " + huso + ". Datum REGCAN95.";
        crsTextLongitudes = crsTextLongitudesCorto + "\nLas altitudes se refieren al nivel medio del Océano Atlántico en el Puerto del Rosario. Mareógrafo del IGN.\n";
        break;
      case 8:
        crsText = "Elipsoide SGR80. Proyección U.T.M. Datum REGCAN95. ";
        crsTextPoster = "Elipsoide SGR80. Proyección U.T.M. Huso " + huso + ". Datum REGCAN95.";
        crsTextLongitudes = crsTextLongitudesCorto + "\nLas altitudes se refieren al nivel medio del Océano Atlántico en Santa Cruz de Tenerife. Mareógrafo del IGN.\n";
        break;
      case 9:
        crsText = "Elipsoide SGR80. Proyección U.T.M. Datum REGCAN95. ";
        crsTextPoster = "Elipsoide SGR80. Proyección U.T.M. Huso " + huso + ". Datum REGCAN95.";
        crsTextLongitudes = crsTextLongitudesCorto + "\nLas altitudes se refieren al nivel medio del Océano Atlántico en San Sebastián de la Gomera a\n partir de datos del Instituto Hidrográfico de la Marina.\n";
        break;
      case 10:
        crsText = "Elipsoide SGR80. Proyección U.T.M. Datum REGCAN95. ";
        crsTextPoster = "Elipsoide SGR80. Proyección U.T.M. Huso " + huso + ". Datum REGCAN95.";
        crsTextLongitudes = crsTextLongitudesCorto + "\nLas altitudes se refieren al nivel medio del Océano Atlántico en el Puerto de la Luz. Mareógrafo del Instituto Español de Oceanografía.\n";
        break;
      case 11:
        crsText = "Elipsoide SGR80. Proyección U.T.M. Datum REGCAN95. ";
        crsTextPoster = "Elipsoide SGR80. Proyección U.T.M. Huso " + huso + ". Datum REGCAN95.";
        crsTextLongitudes = crsTextLongitudesCorto + "\nLas altitudes se refieren al nivel medio del Océano Atlántico en el Puerto de la Estaca. Mareógrafo de Puertos del Estado.\n";
        break;
      default:
        crsText = "Elipsoide SGR80. Proyección U.T.M. Datum ETRS89. ";
        crsTextPoster = "Elipsoide SGR80. Proyección U.T.M. Huso " + huso + ". Datum ETRS89.";
        crsTextLongitudes = crsTextLongitudesCorto + "\nLas altitudes se refieren al nivel medio del Mediterráneo en Alicante. Mareógrafo del IGN.\n";
    }

    //             0        1          2        3        4       5        6        7         8             9          10           11
    var months = ["enero", "febrero", "marzo", "abril", "mayo", "junio", "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"];

    let agradecimientos;
    let creditosMapa;
    let diaActual = new Date().getDate();
    let mesActual = months[new Date().getMonth()];
    let añoActual = new Date().getFullYear();

    let routesLicenses = '';
    state.mapa.getLayers().forEach((l) => {
      if (l.type === 'Vector' && l.getFeatures().length > 0 && l.getImpl().getOL3Layer() !== null && l.getImpl().getOL3Layer().values_.credits !== undefined) {
        const lic = l.getImpl().getOL3Layer().values_.credits.replace(/\.$/, '');
        if (routesLicenses === '') {
          routesLicenses += lic;
        } else if (routesLicenses.indexOf(lic) === -1) {
          routesLicenses += `, ${lic}`;
        }
      }
    });

    // LEYENDAS
    if (state.scale === "1:10.000" || state.scale === "1:25.000" || state.scale === "1:20.000" || state.scale === "1:30.000") {
      if (layout === "landscape" || layout === "landscape_R") {
        legend[0] = state.ruteServerImagenesLeyendas + 'img12.png'; //CURRENTSIGNS1
        legend[1] = state.ruteServerImagenesLeyendas + 'img13.png'; //CURRENTSIGNS2
        legend[2] = state.ruteServerImagenesLeyendas + 'img14.png'; //CURRENTSIGNS3
        legend[3] = state.ruteServerImagenesLeyendas + 'img15.png'; //POPULATION CORE
        legend[4] = state.ruteServerImagenesLeyendas + 'img16.png'; //LAND USE
      } else if (layout === "poster_L"){
        legend[0] = state.ruteServerImagenesLeyendas + 'img12_LV.png'; //CURRENTSIGNS1
        legend[1] = state.ruteServerImagenesLeyendas + 'img13_LV.png'; //CURRENTSIGNS2
        legend[2] = state.ruteServerImagenesLeyendas + 'img14_LV.png'; //CURRENTSIGNS3
        legend[3] = state.ruteServerImagenesLeyendas + 'img15_LV.png'; //POPULATION CORE
        legend[4] = state.ruteServerImagenesLeyendas + 'img16_LV.png'; //LAND USE
      } else {
        legend[0] = state.ruteServerImagenesLeyendas + 'img12_R.png'; //CURRENTSIGNS1
        legend[1] = state.ruteServerImagenesLeyendas + 'img13_R.png'; //CURRENTSIGNS2
        legend[2] = state.ruteServerImagenesLeyendas + 'img14_R.png'; //CURRENTSIGNS3
        legend[3] = state.ruteServerImagenesLeyendas + 'img15_R.png'; //POPULATION CORE
        legend[4] = state.ruteServerImagenesLeyendas + 'img16_R.png'; //LAND USE
      }

      if (producto === 'Poster') {//if (state.active === 6 || state.active === 7) { //POSTER MTN25
        if (layout.endsWith("_L")){ //Poster con leyenda
          crsText = crsText + '\n' + crsTextLongitudes + "Equidistancia de las curvas de nivel 10 metros. Intercaladas 5 metros."+ (state.gridFrame==="active"||state.coordinatesFrame==="active"?"\nLas coordenadas azules corresponden a la cuadrícula kilométrica U.T.M.":"");
          let tempLicenses = '';
          if (routesLicenses !== '') {
            tempLicenses = "\nRutas cargadas bajo licencia " + routesLicenses + ".";
          }
          agradecimientos = textoResponsabilidadOCodigosEspeciales+"\nMapa a la Carta " + (codigosLegales?"Especial compuesto por © ":"compuesto por ") + state.author + " el " + diaActual + " de " + mesActual + " de " + añoActual + ".\nObra derivada del MTN25 raster CC BY 4.0 ign.es. Email: consulta@cnig.es."+tempLicenses+"\nCrea tu propio mapa en: https://mapaalacarta.cnig.es";
        }else{
          crsText = "Escala " + state.scale + ". " + crsTextPoster + '\n'+ crsTextLongitudes.replace('a\n', 'a') + "Equidistancia de las curvas de nivel 10 metros. Intercaladas 5 metros." + (state.gridFrame==="active"||state.coordinatesFrame==="active"?" Las coordenadas azules corresponden a la cuadrícula kilométrica U.T.M.":"");
          let tempLicenses = '';
          if (routesLicenses !== '') {
            tempLicenses = " Rutas cargadas bajo licencia " + routesLicenses + ".";
          }
          agradecimientos = "Información geográfica generada automáticamente en " + date + " a partir de la BTN y la IGR con la última información disponible.\n"+textoResponsabilidadOCodigosEspeciales+"\nMapa a la Carta " + (codigosLegales?"Especial compuesto por © ":"compuesto por ") + state.author + " el " + diaActual + " de " + mesActual + " de " + añoActual + ". Obra derivada del MTN25 raster CC BY 4.0 ign.es."+tempLicenses+"\nEmail: consulta@cnig.es. Crea tu propio mapa o foto aérea en: https://mapaalacarta.cnig.es";
        }
      } else if (producto === 'Foto') {//} else if (state.active > 7) { //PNOA25 y 10
        crsText = "Escala " + state.scale + ". " + crsTextPoster + "\n" + crsTextLongitudesCorto + (state.gridFrame==="active"||state.coordinatesFrame==="active"?"\nLas coordenadas azules corresponden a la cuadrícula kilométrica U.T.M.":"");
        let tempLicenses = '';
        if (routesLicenses !== '') {
          tempLicenses = " Rutas cargadas bajo licencia " + routesLicenses + ".";
        }
        agradecimientos = "La base cartográfica es la ortofotografía del Plan Nacional de Ortofotografía Aérea. Fecha de vuelo " + date + ".\n"+textoResponsabilidadOCodigosEspeciales+"\nFoto a la Carta " + (codigosLegales?"Especial compuesta por © ":"compuesta por ") + state.author + " el " + diaActual + " de " + mesActual + " de " + añoActual + ". Obra derivada de PNOA CC BY 4.0 scne.es. "+tempLicenses+"\nEmail: consulta@cnig.es. Crea tu propio mapa o foto: https://mapaalacarta.cnig.es";
      } else if (producto === 'Elaborado') {//} else { //MAPA CARTELA MTN25
        crsText = crsText + crsTextLongitudes + "Equidistancia de las curvas de nivel 10 metros. Intercaladas 5 metros."+ (state.gridFrame==="active"||state.coordinatesFrame==="active"?"\nLas coordenadas azules corresponden a la cuadrícula kilométrica U.T.M.":"");
        agradecimientos = "Agradecemos al público usuario la colaboración en la localización de posibles errores y omisiones.\nMapa a la Carta " + (codigosLegales?"Especial compuesto por © ":"compuesto por ") + state.author + ".\n Obra derivada del MTN25 raster CC BY 4.0 ign.es.";
        if (routesLicenses !== '') {
          agradecimientos += "\nRutas cargadas bajo licencia " + routesLicenses + ".";
        }
        agradecimientos += "\nCreado el " + diaActual + " de " + mesActual + " de " + añoActual + ".";
        creditosMapa = "Información geográfica generada automáticamente en " + date + " a partir de la Base Topográfica Nacional (BTN) y la Información Geográfica de Referencia (IGR) con la última información disponible.\n"+textoResponsabilidadOCodigosEspeciales;
      }
    } else if (state.scale === "1:40.000" || state.scale === "1:50.000" || state.scale === "1:60.000") {
      if (layout === "landscape" || layout === "landscape_R") {
        legend[0] = state.ruteServerImagenesLeyendas + 'img17.png'; //CURRENTSIGNS1
        legend[1] = state.ruteServerImagenesLeyendas + 'img18.png'; //CURRENTSIGNS2
        legend[2] = state.ruteServerImagenesLeyendas + 'img19.png'; //CURRENTSIGNS3
        legend[3] = state.ruteServerImagenesLeyendas + 'img20.png'; //POPULATION CORE
        legend[4] = state.ruteServerImagenesLeyendas + 'img21.png'; //LAND USE
      } else if (layout === "poster_L"){
        legend[0] = state.ruteServerImagenesLeyendas + 'img17_LV.png'; //CURRENTSIGNS1
        legend[1] = state.ruteServerImagenesLeyendas + 'img18_LV.png'; //CURRENTSIGNS2
        legend[2] = state.ruteServerImagenesLeyendas + 'img19_LV.png'; //CURRENTSIGNS3
        legend[3] = state.ruteServerImagenesLeyendas + 'img15_LV.png'; //POPULATION CORE reemplazado 'img20_LV.png' por el 15 ya que es más detallado
        legend[4] = state.ruteServerImagenesLeyendas + 'img21_LV.png'; //LAND USE
      } else {
        legend[0] = state.ruteServerImagenesLeyendas + 'img17_R.png'; //CURRENTSIGNS1
        legend[1] = state.ruteServerImagenesLeyendas + 'img18_R.png'; //CURRENTSIGNS2
        legend[2] = state.ruteServerImagenesLeyendas + 'img19_R.png'; //CURRENTSIGNS3
        legend[3] = state.ruteServerImagenesLeyendas + 'img20_R.png'; //POPULATION CORE
        legend[4] = state.ruteServerImagenesLeyendas + 'img21_R.png'; //LAND USE
      }

      if (producto === 'Poster') { //if (state.active >= 6) { //POSTER MTN50
        if (layout.endsWith("_L")){ //Poster con leyenda
          crsText = crsText + '\n' + crsTextLongitudes + "Equidistancia de las curvas de nivel 20 metros."+ (state.gridFrame==="active"||state.coordinatesFrame==="active"?"\nLas coordenadas azules corresponden a la cuadrícula kilométrica U.T.M.":"");
          let tempLicenses = '';
          if (routesLicenses !== '') {
            tempLicenses = "\nRutas cargadas bajo licencia " + routesLicenses + ".";
          }
          agradecimientos = textoResponsabilidadOCodigosEspeciales+"\nMapa a la Carta " + (codigosLegales?"Especial compuesto por © ":"compuesto por ") + state.author + " el " + diaActual + " de " + mesActual + " de " + añoActual + ".\nObra derivada del MTN50 raster CC BY 4.0 ign.es. Email: consulta@cnig.es."+tempLicenses+"\nCrea tu propio mapa o foto aérea en: https://mapaalacarta.cnig.es";
        }else{
          crsText = "Escala " + state.scale + ". " + crsTextPoster + '\n'+ crsTextLongitudes.replace('a\n', 'a') + "Equidistancia de las curvas de nivel 20 metros." +(state.gridFrame==="active"||state.coordinatesFrame==="active"?" Las coordenadas azules corresponden a la cuadrícula kilométrica U.T.M.":"");
          let tempLicenses = '';
          if (routesLicenses !== '') {
            tempLicenses = " Rutas cargadas bajo licencia " + routesLicenses + ".";
          }
          agradecimientos = "Información geográfica generada automáticamente en " + date + " a partir de la BTN y la IGR con la última información disponible.\n"+textoResponsabilidadOCodigosEspeciales+"\nMapa a la Carta " + (codigosLegales?"Especial compuesto por © ":"compuesto por ") + state.author + " el " + diaActual + " de " + mesActual + " de " + añoActual + ". Obra derivada del MTN50 raster CC BY 4.0 ign.es. "+tempLicenses+"\nEmail: consulta@cnig.es. Crea tu propio mapa o foto aérea: https://mapaalacarta.cnig.es";
        }
      } else if(producto === 'Elaborado') {//} else { //MAPA CARTELA MTN50
        crsText = crsText + crsTextLongitudes + "Equidistancia de las curvas de nivel 20 metros."+ (state.gridFrame==="active"||state.coordinatesFrame==="active"?"\nLas coordenadas azules corresponden a la cuadrícula kilométrica U.T.M.":"");
        agradecimientos = "Agradecemos al público usuario la colaboración en la localización de posibles errores y omisiones.\n Mapa a la Carta " + (codigosLegales?"Especial compuesto por © ":"compuesto por ") + state.author + ".\n Obra derivada del MTN50 raster CC BY 4.0 ign.es.";
        if (routesLicenses !== '') {
          agradecimientos += "\nRutas cargadas bajo licencia " + routesLicenses + ".";
        }

        agradecimientos += "\nCreado el " + diaActual + " de " + mesActual + " de " + añoActual + ".";
        creditosMapa = "Información geográfica generada automáticamente en " + date + " a partir de la Base Topográfica Nacional (BTN) y la Información Geográfica de Referencia (IGR) con la última información disponible.\n"+textoResponsabilidadOCodigosEspeciales;
      }
    } else {
      if (producto === 'Foto') {//if (state.active > 7) { //PNOA 5k y 2.5k
        crsText = "Escala " + state.scale + ". " + crsTextPoster + "\n"+ crsTextLongitudesCorto + (state.gridFrame==="active"||state.coordinatesFrame==="active"?"\nLas coordenadas azules corresponden a la cuadrícula kilométrica U.T.M.":"");
        let tempLicenses = '';
        if (routesLicenses !== '') {
          tempLicenses = " Rutas cargadas bajo licencia " + routesLicenses + ".";
        }
        agradecimientos = "La base cartográfica es la ortofotografía del Plan Nacional de Ortofotografía Aérea. Fecha de vuelo " + date + ".\n"+textoResponsabilidadOCodigosEspeciales+"\nFoto a la Carta " + (codigosLegales?"Especial compuesta por © ":"compuesta por ") + state.author + " el " + diaActual + " de " + mesActual + " de " + añoActual + ". Obra derivada de PNOA CC BY 4.0 scne.es."+tempLicenses+"\nEmail: consulta@cnig.es. Crea tu propio mapa o foto: https://mapaalacarta.cnig.es";
      } else { //¿Aquí entra alguna vez?
        crsText = "Escala " + state.scale + "." + crsText + "\nMapa a la Carta " + (codigosLegales?"Especial compuesto por © ":"compuesto por ") + state.author + " el " + diaActual + " de " + mesActual + " de " + añoActual + ". Obra derivada del MTN50 raster CC BY 4.0 ign.es.";
        let tempLicenses = '';
        if (routesLicenses !== '') {
          tempLicenses = " Rutas cargadas bajo licencia " + routesLicenses + ".";
        }
        agradecimientos = "Información geográfica generada automáticamente en " + date + " a partir de la Base Topográfica Nacional (BTN) y la Información Geográfica de Referencia (IGR) con la última información disponible.\n"+textoResponsabilidadOCodigosEspeciales+tempLicenses+"\nEmail: consulta@cnig.es. Crea tu propio mapa: https://mapaalacarta.cnig.es";
      }
    }

    let imgcircle1;
    let imgcircle2;
    let imgcircle3;
    let imgcircle4;
    let imgTitleQR;
    let imgTitleMACFront;
    let gradient;

    // --------------------------------------------------------------> PLANTILLA HORIZONTAL
    let rotation;
    let rotation2;
    //imgTransparent = state.ruteServerImagenesComunes + 'img199.png';
    scaleImg = state.ruteServerImagenesEscalas;

    // OBTENCIÓN DE LA IMAGEN QUE SE USARÁ EN LA PORTADA EN FUNCIÓN DEL COLOR SELECCIONADO
    switch (colorFront) {
      case "#00a75d":
        mainImg = state.ruteServerImagenesFondos + "img54.png";
        mainImgBack = state.ruteServerImagenesFondos + "img46.png";
        break;
      case "#985fa4":
        mainImg = state.ruteServerImagenesFondos + "img55.png";
        mainImgBack = state.ruteServerImagenesFondos + "img47.png";
        break;
      case "#5db3ae":
        mainImg = state.ruteServerImagenesFondos + "img53.png";
        mainImgBack = state.ruteServerImagenesFondos + "img45.png";
        break;
      case "#952616":
        mainImg = state.ruteServerImagenesFondos + "img52.png";
        mainImgBack = state.ruteServerImagenesFondos + "img44.png";
        break;
      case "#f7a941":
        mainImg = state.ruteServerImagenesFondos + "img51.png";
        mainImgBack = state.ruteServerImagenesFondos + "img43.png";
        break;
      case "#946a43":
        mainImg = state.ruteServerImagenesFondos + "img50.png";
        mainImgBack = state.ruteServerImagenesFondos + "img42.png";
        break;
      case "#858584":
        mainImg = state.ruteServerImagenesFondos + "img49.png";
        mainImgBack = state.ruteServerImagenesFondos + "img41.png";
        break;
      case "#184962":
        mainImg = state.ruteServerImagenesFondos + "img48.png";
        mainImgBack = state.ruteServerImagenesFondos + "img40.png";
        break;
      default:
        mainImg = state.ruteServerImagenesFondos + "img54.png";
        mainImgBack = state.ruteServerImagenesFondos + "img46.png";
    }

    if (layout === "landscape" || layout === "landscape_R") {
      spacingMap5 = spacingB;
      spacingMap2 = spacingA;
      rotation = 0;
      qrcode = state.ruteServerImagenesComunes + "img11.png";
      logo_map = state.ruteServerImagenesComunes + 'img01.png';
      logoMapaALaCartaCorner = state.ruteServerImagenesComunes + "img02.png";

      if (layout === "landscape") {//Landscape
        rotation2 = 0;
        imgcircle1 = state.ruteServerImagenesComunes + 'img04.png';
        imgcircle2 = state.ruteServerImagenesComunes + 'img05.png';
        imgcircle3 = state.ruteServerImagenesComunes + 'img06.png';
        imgcircle4 = state.ruteServerImagenesComunes + 'img07.png';
        imgTitleQR = state.ruteServerImagenesComunes + 'img10.png';
        gradient = state.ruteServerImagenesComunes + 'img72.png';
        imgArrow = state.ruteServerImagenesComunes + "img00.png";
        imgTitleMACFront = state.ruteServerImagenesComunes + 'img03.png';
        logoMapaALaCarta = state.ruteServerImagenesComunes + "img02.png";
        logo_cover = state.ruteServerImagenesComunes + 'img01.png';
      } else {//Landscape_R
        rotation2 = 90;
        imgcircle1 = state.ruteServerImagenesComunes + 'img04_R.png';
        imgcircle2 = state.ruteServerImagenesComunes + 'img05_R.png';
        imgcircle3 = state.ruteServerImagenesComunes + 'img06_R.png';
        imgcircle4 = state.ruteServerImagenesComunes + 'img07_R.png';
        imgTitleQR = state.ruteServerImagenesComunes + 'img10_R.png';
        gradient = state.ruteServerImagenesComunes + 'img72_R.png';
        imgArrow = state.ruteServerImagenesComunes + "img00_R.png";
        imgTitleMACFront = state.ruteServerImagenesComunes + 'img03_R.png';
        logoMapaALaCarta = state.ruteServerImagenesComunes + "img02_R.png";
        logo_cover = state.ruteServerImagenesComunes + 'img01_R.png';
      }

      switch (state.scale) {
        case '1:25.000':
          scaleImg = scaleImg + 'E25k.png';
          break;
        case '1:20.000':
          scaleImg = scaleImg + 'E20k.png';
          break;
        case '1:30.000':
          scaleImg = scaleImg + 'E30k.png';
          break;
        case '1:40.000':
          scaleImg = scaleImg + 'E40k.png';
          break;
        case '1:50.000':
          scaleImg = scaleImg + 'E50k.png';
          break;
        case '1:60.000':
          scaleImg = scaleImg + 'E60k.png';
          break;
        default:
          scaleImg = scaleImg + 'E25k.png';
      }
    } else if (layout === "portrait" || layout === 'portrait_R') {
      spacingMap5 = spacingA;
      spacingMap2 = spacingB;
      rotation = 90;
      qrcode = state.ruteServerImagenesComunes + "img11.png";
      logo_map = state.ruteServerImagenesComunes + 'img01_R.png';
      logoMapaALaCartaCorner = state.ruteServerImagenesComunes + "img02_R.png";

      if(layout === "portrait"){//Portrait
        rotation2 = 0;
        imgArrow = state.ruteServerImagenesComunes + "img00.png";
        imgTitleMACFront = state.ruteServerImagenesComunes + 'img03.png';
        imgcircle1 = state.ruteServerImagenesComunes + 'img04.png';
        imgcircle2 = state.ruteServerImagenesComunes + 'img05.png';
        imgcircle3 = state.ruteServerImagenesComunes + 'img06.png';
        imgcircle4 = state.ruteServerImagenesComunes + 'img07.png';
        imgTitleQR = state.ruteServerImagenesComunes + 'img10.png';
        gradient = state.ruteServerImagenesComunes + 'img72.png';
        logoMapaALaCarta = state.ruteServerImagenesComunes + "img02.png";
        logo_cover = state.ruteServerImagenesComunes + 'img01.png';
      }else{//Portrait_R
        rotation2 = 90;
        imgArrow = state.ruteServerImagenesComunes + "img00_R.png";
        imgTitleMACFront = state.ruteServerImagenesComunes + 'img03_R.png';
        imgcircle1 = state.ruteServerImagenesComunes + 'img04_R.png';
        imgcircle2 = state.ruteServerImagenesComunes + 'img05_R.png';
        imgcircle3 = state.ruteServerImagenesComunes + 'img06_R.png';
        imgcircle4 = state.ruteServerImagenesComunes + 'img07_R.png';
        imgTitleQR = state.ruteServerImagenesComunes + 'img10_R.png';
        gradient = state.ruteServerImagenesComunes + 'img72_R.png';
        logoMapaALaCarta = state.ruteServerImagenesComunes + "img02_R.png";
        logo_cover = state.ruteServerImagenesComunes + 'img01_R.png';
      }
      switch (state.scale) {
        case '1:25.000':
          scaleImg = scaleImg + 'E25k_m_R.png';
          break;
        case '1:20.000':
          scaleImg = scaleImg + 'E20k_m_R.png';
          break;
        case '1:30.000':
          scaleImg = scaleImg + 'E30k_m_R.png';
          break;
        case '1:40.000':
          scaleImg = scaleImg + 'E40k_m_R.png';
          break;
        case '1:50.000':
          scaleImg = scaleImg + 'E50k_m_R.png';
          break;
        case '1:60.000':
          scaleImg = scaleImg + 'E60k_m_R.png';
          break;
        default:
          scaleImg = scaleImg + 'E25k_m_R.png';
      }
    } else if (layout === "poster" || layout === "poster_L") {
      logo_map = state.ruteServerImagenesComunes + 'img01.png';
      logoMapaALaCartaCorner = state.ruteServerImagenesComunes + "img02.png";
      spacingMap5 = spacingB;
      spacingMap2 = spacingA;
      rotation = 0;
      rotation2 = 0;
      if (layout === "poster_L") {
        switch (state.scale) {
          case '1:25.000':
            scaleImg = scaleImg + 'E25k_m.png';
            break;
          case '1:20.000':
            scaleImg = scaleImg + 'E20k_m.png';
            break;
          case '1:30.000':
            scaleImg = scaleImg + 'E30k_m.png';
            break;
          case '1:40.000':
            scaleImg = scaleImg + 'E40k_m.png';
            break;
          case '1:50.000':
            scaleImg = scaleImg + 'E50k_m.png';
            break;
          case '1:60.000':
            scaleImg = scaleImg + 'E60k_m.png';
            break;
          default:
            scaleImg = scaleImg + 'E25k_m.png';
        }
      } else {
        switch (state.scale) {
          case '1:25.000':
            scaleImg = scaleImg + 'E25k.png';
            break;
          case '1:20.000':
            scaleImg = scaleImg + 'E20k.png';
            break;
          case '1:30.000':
            scaleImg = scaleImg + 'E30k.png';
            break;
          case '1:40.000':
            scaleImg = scaleImg + 'E40k.png';
            break;
          case '1:50.000':
            scaleImg = scaleImg + 'E50k.png';
            break;
          case '1:60.000':
            scaleImg = scaleImg + 'E60k.png';
            break;
          default:
            scaleImg = scaleImg + 'E25k.png';
        }
      }
    } else if (layout === "posterPortrait" || layout === "posterPortrait_L") {
      rotation = 90;
      rotation2 = 0;
      logo_map = state.ruteServerImagenesComunes + 'img01_R.png';
      logoMapaALaCartaCorner = state.ruteServerImagenesComunes + "img02_R.png";
      spacingMap5 = spacingA;
      spacingMap2 = spacingB;
      if (layout === "posterPortrait_L") {
        switch (state.scale) {
          case '1:25.000':
            scaleImg = scaleImg + 'E25k_m_R.png';
            break;
          case '1:20.000':
            scaleImg = scaleImg + 'E20k_m_R.png';
            break;
          case '1:30.000':
            scaleImg = scaleImg + 'E30k_m_R.png';
            break;
          case '1:40.000':
            scaleImg = scaleImg + 'E40k_m_R.png';
            break;
          case '1:50.000':
            scaleImg = scaleImg + 'E50k_m_R.png';
            break;
          case '1:60.000':
            scaleImg = scaleImg + 'E60k_m_R.png';
            break;
          default:
            scaleImg = scaleImg + 'E25k_m_R.png';
        }
      } else {
        switch (state.scale) {
          case '1:25.000':
            scaleImg = scaleImg + 'E25k_R.png';
            break;
          case '1:20.000':
            scaleImg = scaleImg + 'E20k_R.png';
            break;
          case '1:30.000':
            scaleImg = scaleImg + 'E30k_R.png';
            break;
          case '1:40.000':
            scaleImg = scaleImg + 'E40k_R.png';
            break;
          case '1:50.000':
            scaleImg = scaleImg + 'E50k_R.png';
            break;
          case '1:60.000':
            scaleImg = scaleImg + 'E60k_R.png';
            break;
          default:
            scaleImg = scaleImg + 'E25k_R.png';
        }
      }
    }

    if(state.serImgC){
      let imgName = state.serImgC[index].imageName;
      if (imgName !== 'custom') {
        imageFront = state.ruteServerImagenesPortada + imgName;
        imageFrontCustom = oneTransparentPixel;
      } else {
        imageFront = "/imagenes/comunes/img199.png";
        if (state.serImgC[index].imageRotatedForVertical && (layout === 'portrait_R' || layout === 'landscape_R')) {//Requiered rotation of image for Print (layout === "portrait" ||
          imageFrontCustom = state.serImgC[index].imageRotatedForVertical.split('base64,')[1];
        } else {
          imageFrontCustom = state.serImgC[index].image.split('base64,')[1];
        }
      }
    } else {
      let imgName = state.imageName;
      if (imgName !== 'custom') {
        imageFront = state.ruteServerImagenesPortada + imgName;
        imageFrontCustom = oneTransparentPixel;
      } else {
        imageFront = "/imagenes/comunes/img199.png";
        if (state.imageRotatedForVertical && (layout === 'portrait_R' || layout === 'landscape_R')) {//Requiered rotation of image for Print (layout === "portrait" ||
          imageFrontCustom = state.imageRotatedForVertical.split('base64,')[1];
        } else {
          imageFrontCustom = state.image.split('base64,')[1];
        }
      }
    }

    // -------------------------------> COMUNES A AMBAS PLANTILLAS

    switch (state.scale) {
      case '1:2.500':
        baseNameSheets = properties.ECW25k_FILE_NAME;
        ruteServerECWS = ruteServerECWS + HUSO25;
        scaleTransformed = 2500;
        break;
      case '1:5.000':
        baseNameSheets = properties.ECW25k_FILE_NAME;
        ruteServerECWS = ruteServerECWS + HUSO25;
        scaleTransformed = 5000;
        break;
      case '1:10.000':
        baseNameSheets = properties.ECW25k_FILE_NAME;
        ruteServerECWS = ruteServerECWS + HUSO25;
        scaleTransformed = 10000;
        break;
      case '1:25.000':
        baseNameSheets = properties.ECW25k_FILE_NAME;
        ruteServerECWS = ruteServerECWS + HUSO25;
        scaleTransformed = 25000;
        break;
      case '1:20.000':
        baseNameSheets = properties.ECW25k_FILE_NAME;
        ruteServerECWS = ruteServerECWS + HUSO25;
        scaleTransformed = 20000;
        break;
      case '1:30.000':
        baseNameSheets = properties.ECW25k_FILE_NAME;
        ruteServerECWS = ruteServerECWS + HUSO25;
        scaleTransformed = 30000;
        break;
      case '1:40.000':
        baseNameSheets = properties.ECW50k_FILE_NAME;
        ruteServerECWS = ruteServerECWS + HUSO50;
        scaleTransformed = 40000;
        break;
      case '1:50.000':
        baseNameSheets = properties.ECW50k_FILE_NAME;
        ruteServerECWS = ruteServerECWS + HUSO50;
        scaleTransformed = 50000;
        break;
      case '1:60.000':
        baseNameSheets = properties.ECW50k_FILE_NAME;
        ruteServerECWS = ruteServerECWS + HUSO50;
        scaleTransformed = 60000;
        break;
      default:
        baseNameSheets = properties.ECW25k_FILE_NAME;
        ruteServerECWS = ruteServerECWS + HUSO25;
        scaleTransformed = 2500;
    }

    const usedHusos = [huso];
    state.sheets[index].forEach((s) => {
      const solape = s.getAttribute('SOLAPE');
      const aux = s.getAttribute('HUSO');
      if (solape === null && usedHusos.indexOf(aux) === -1) {
        usedHusos.push(aux);
      }
    });

    // NAME OF SHEETS
    if (producto === 'Elaborado' || producto === 'Poster'){//if (state.active < 8){
      let attributeSearch;
      if (scaleTransformed === 50000 || scaleTransformed === 40000 || scaleTransformed === 60000) {
        attributeSearch = 'MTN50_CLAS';
      } else if (scaleTransformed === 25000 || scaleTransformed === 30000 || scaleTransformed === 20000) {
        attributeSearch = 'NUMERO';
      }

      for (let i = 0; i < state.sheets[index].length; i++) {
        let innerHuso = state.sheets[index][i].getAttribute('HUSO');
        const solape = state.sheets[index][i].getAttribute('SOLAPE');
        if (usedHusos.indexOf(innerHuso) === -1 && solape !== null) {
          if (usedHusos.indexOf('29') > -1 && solape.indexOf('29-30') > -1) {
            innerHuso = '29';
          } if (usedHusos.indexOf('30') > -1 && solape.indexOf('29-30') > -1) {
            innerHuso = '30';
          } else if (usedHusos.indexOf('30') > -1 && solape.indexOf('30-31') > -1) {
            innerHuso = '30';
          } else if (usedHusos.indexOf('31') > -1 && solape.indexOf('30-31') > -1) {
            innerHuso = '31';
          }
        }

        let aux = baseNameSheets + projection + '_' + state.sheets[index][i].getAttribute(attributeSearch) + '.ecw';
        if (huso === '28') {
          const separator = 'epsg326' + aux.split('epsg326')[1].split('_')[0];
          aux = aux.split(separator).join('epsg326' + innerHuso);
        } else {
          const separator = 'epsg258' + aux.split('epsg258')[1].split('_')[0];
          aux = aux.split(separator).join('epsg258' + innerHuso);
        }

        sheets[i] = aux;
        let path = ruteServerECWS + sheets[i];
        const separator2 = 'HUSO' + path.split('HUSO')[1].split('/')[0];
        path = path.split(separator2).join('HUSO' + innerHuso);
        layersSheets.push({
          "type": "ecw",
          "url": path,
        });
      }
    } else {
      if (Object.keys(state.activeServices).length > 0){
        for (const [name, url] of Object.entries(state.activeServices)){
          layersSheets.push({
            baseURL: url,
            customParams: {
              TRANSPARENT: true,
              // format_options: 'dpi:375',
              format_options: 'dpi:300',
            },
            layers: [name],
            opacity: 1,
            styles: [""],
            type: "WMS"
          })
        }
      }

      if (properties.PNOA_MODE === 'LOCAL') {
        for (let i = 0; i < state.sheets[index].length; i++) {
          const sheet = state.sheets[index][i];
          const tipo = sheet.getAttribute('TIPO'); // 'MA' o 'OV'
          let innerHuso = sheet.getAttribute('HUSO');
          const solape = sheet.getAttribute('SOLAPE');
          let fileName = '';
          
          // Ajuste de huso en zonas de solape
          if (usedHusos.indexOf(innerHuso) === -1 && solape !== null) {
            if (usedHusos.indexOf('29') > -1 && solape.indexOf('29-30') > -1) {
              innerHuso = '29';
            } else if (usedHusos.indexOf('30') > -1 && solape.indexOf('29-30') > -1) {
              innerHuso = '30';
            } else if (usedHusos.indexOf('30') > -1 && solape.indexOf('30-31') > -1) {
              innerHuso = '30';
            } else if (usedHusos.indexOf('31') > -1 && solape.indexOf('30-31') > -1) {
              innerHuso = '31';
            }
          }

          // La ruta y nombre del TIF se resuelve distinto para OV y para MA
          if (tipo === 'OV') {
            // OV:
            // - carpeta por huso: PNOA_OV_H29, PNOA_OV_H30, etc.
            // - sin lógica 30N / 30S
            // - nombre exacto del TIFF en la huella geojson, con extensión incluida
            const folderName = properties.PNOA_OV_FOLDER_NAME.replace('${huso}', innerHuso);
            const ovFileName = sheet.getAttribute('NOMBRE');

            fileName = `${folderName}/${ovFileName}`;
          } else {
            // MA normal: se mantiene la lógica actual
            fileName = properties.PNOA_FILE_NAME;

            let numPnoa50= sheet.getAttribute('NUMERO').split("_")[0];
            if (isNaN(numPnoa50)) {
              numPnoa50=numPnoa50.slice(0, -1);
            }

            if (innerHuso === '30' && Number(numPnoa50) > properties.LIMIT_SHEET_PNOA_NORTH) {
              fileName = fileName.replace('${huso}', '30S');
              fileName = fileName.replace('${huso}', '30');
            } else if (innerHuso === '30' && Number(numPnoa50) <= properties.LIMIT_SHEET_PNOA_NORTH) {
              fileName = fileName.replace('${huso}', '30N');
              fileName = fileName.replace('${huso}', '30');
            } else {
              fileName = fileName.replaceAll('${huso}', innerHuso);
            }

            fileName = fileName.replace('${src}', innerHuso === '28' ? 'REGC95' : 'ETRS89');
            fileName = fileName.replace('${hoja}', state.sheets[index][i].getAttribute('NUMERO'));

          }

          sheets[i] = fileName;
          layersSheets.push({
            "type": "geotiff",
            "url": properties.ruteServerPNOA + '/' + sheets[i]
          });
        }

      } else {
        layersSheets.push({
          "opacity": "1",
          "type": "osm",
          "baseURL": "https://tms-pnoa-ma.idee.es/1.0.0/pnoa-ma/{z}/{x}/{-y}.jpeg",
          "maxExtent": [-20037508.342789244, -20037508.342789244, 20037508.342789244, 20037508.342789244],
          "tileSize": [256, 256],
          "resolutions": [
            156543.03392804097,
            78271.51696402048,
            39135.75848201024,
            19567.87924100512,
            9783.93962050256,
            4891.96981025128,
            2445.98490512564,
            1222.99245256282,
            611.49622628141,
            305.748113140705,
            152.8740565703525,
            76.43702828517625,
            38.21851414258813,
            19.109257071294063,
            9.554628535647032,
            4.777314267823516,
            2.388657133911758,
            1.194328566955879,
            0.5971642834779395,
            0.29858214173896974,
            0.14929107086948487,
            0.07464553543474244,
            0.03732276771737122,
            0.01866138385868561,
            0.009330691929342804,
            0.004665345964671402,
            0.002332672982335701,
            0.0011663364911678506,
            0.0005831682455839253,
            0.00029158412279196264,
            0.00014579206139598132,
            0.00007289603069799066,
            0.00003644801534899533,
            0.000018224007674497665,
            0.000009112003837248832,
            0.000004556001918624416,
            0.000002278000959312208,
            0.000001139000479656104,
            5.69500239828052e-7,
            2.84750119914026e-7,
            1.42375059957013e-7,
            7.11875299785065e-8,
            3.559376498925325e-8
          ],
        });
      }
    }

    labelProjection = 'EPSG:' + projection;
    scaleCm = state.scaleCm;
    scaledCenter = ol.proj.transform([
      xy_center[0], xy_center[1]
    ], 'EPSG:3857', labelProjection);
    const scaledCenterMapDef3 = ol.proj.transform([
      xy_center[0], xy_center[1]
    ], 'EPSG:3857', ProyeccionMapaUbicacionPeninsula);
    const scaledCenterMapDef4 = ol.proj.transform([
      xy_center[0], xy_center[1]
    ], 'EPSG:3857', ProyeccionMapaUbicacionCanarias);
    // ------------------------------------
    let coordBotLeft;
    let coordTopLeft;
    let coordBotRight;
    let coordTopRight;
    let xCoordTopLeft;
    let yCoordBotLeft;
    let xCoordTopRight;
    let yCoordTopRight;
    let xCoordBotLeft;
    let yCoordTopLeft;
    let xCoordBotRight;
    let yCoordBotRight;
    let auxScale5 = scaleTransformed / 5;//Factor de escala (scaleTransformed/5000)*1000, como esta en kilometros le multiplicamos 1000 para que concuerde con las coordenadas UTM
    let aux0 = 0;
    let aux1 = 0;

    if (layout === "landscape" || layout === "landscape_R") {
      //Cogemos la distancia (en km) que hay desde el centro al lado correspondiente, lo multiplicamos con el factor de escala
      aux0 = properties.PROPORTION_PIXEL_DISTANCE_LONGSIDE * auxScale5;
      aux1 = properties.PROPORTION_PIXEL_DISTANCE_SHORTSIDE * auxScale5;
    } else if (layout === "portrait" || layout === 'portrait_R') {
      aux0 = properties.PROPORTION_PIXEL_DISTANCE_SHORTSIDE_VERTICAL * auxScale5;
      aux1 = properties.PROPORTION_PIXEL_DISTANCE_LONGSIDE_VERTICAL * auxScale5;
    } else if (layout === "poster" ) {
      aux0 = properties.PROPORTION_PIXEL_DISTANCE_LONGSIDE_POSTER_HORIZONTAL * auxScale5;
      aux1 = properties.PROPORTION_PIXEL_DISTANCE_SHORTSIDE_POSTER_HORIZONTAL * auxScale5;
    } else if ( layout === "poster_L"){
      aux0 = properties.PROPORTION_PIXEL_DISTANCE_LONGSIDE_POSTER_HORIZONTAL_LEYENDA * auxScale5;
      aux1 = properties.PROPORTION_PIXEL_DISTANCE_SHORTSIDE_POSTER_HORIZONTAL_LEYENDA * auxScale5;
    } else if (layout === "posterPortrait") {
      aux0 = properties.PROPORTION_PIXEL_DISTANCE_SHORTSIDE_POSTER_VERTICAL * auxScale5;
      aux1 = properties.PROPORTION_PIXEL_DISTANCE_LONGSIDE_POSTER_VERTICAL * auxScale5;
    } else if (layout === "posterPortrait_L"){
      aux0 = properties.PROPORTION_PIXEL_DISTANCE_SHORTSIDE_POSTER_VERTICAL_LEYENDA * auxScale5;
      aux1 = properties.PROPORTION_PIXEL_DISTANCE_LONGSIDE_POSTER_VERTICAL_LEYENDA * auxScale5;
    }
    let leftCorner = [
      scaledCenter[0] - aux0,
      scaledCenter[1] - aux1
    ];
    let rightCorner = [
      scaledCenter[0] + aux0,
      scaledCenter[1] + aux1
    ];

    //EJEMPLO_DE_MULTIPLES_MAPAS
    coordBotLeft = ol.proj.transform(leftCorner, labelProjection, 'EPSG:4326');
    coordTopLeft = ol.proj.transform([leftCorner[0], rightCorner[1]], labelProjection, 'EPSG:4326');
    coordTopRight = ol.proj.transform(rightCorner, labelProjection, 'EPSG:4326');
    coordBotRight = ol.proj.transform([rightCorner[0], leftCorner[1]], labelProjection, 'EPSG:4326');
    xCoordBotLeft = this.formatCornersCoordinatesMethod(this.converterDecimalToDMS(coordBotLeft[0]));
    yCoordBotLeft = this.formatCornersCoordinatesMethod(this.converterDecimalToDMS(coordBotLeft[1]));
    xCoordTopRight = this.formatCornersCoordinatesMethod(this.converterDecimalToDMS(coordTopRight[0]));
    yCoordTopRight = this.formatCornersCoordinatesMethod(this.converterDecimalToDMS(coordTopRight[1]));
    xCoordTopLeft = this.formatCornersCoordinatesMethod(this.converterDecimalToDMS(coordTopLeft[0]));
    yCoordTopLeft = this.formatCornersCoordinatesMethod(this.converterDecimalToDMS(coordTopLeft[1]));
    xCoordBotRight = this.formatCornersCoordinatesMethod(this.converterDecimalToDMS(coordBotRight[0]));
    yCoordBotRight = this.formatCornersCoordinatesMethod(this.converterDecimalToDMS(coordBotRight[1]));

    let layerGridForMapDef1;
    let layerGridForMapDef2;
    let layerGridForMapDef5;
    let layerGridForMapDef6;
    let layerGridForMapDef7;
    let haloradius = 5;
    let fontsize = 7;
    let pointRadius = 3;
    let centerMapDef3 = [458295.489244, 4370309.338934];
    let strokeWidth = 0.2
    if (producto === 'Foto'){//if (state.active >= 8){
      strokeWidth = 0.5;
    }

    let strokeWidthLabel = 1;
    let scaleMapDef3 = 18000000;
    let scaleMapDef4 = 21000000;
    let verticalXOffset = 1;
    let horizontalYOffset = -1;

    //calculate origin
    origin = this.calculateOrigin(xy_center, labelProjection, spacing);

    // calculate grid layer
    if (state.gridFrame === 'active') {
      let layers1 = {
        "type": "grid",
        "gridType": "LINES",
        "style": {
          "version": "2",
          "*": {
            "symbolizers": [
              {
                "type": "line",
                "strokeColor": "#009FE3",
                "strokeOpacity": 1,
                "strokeWidth": strokeWidth,
                "strokeLinecap": "round"
              }
            ]
          }
        },
        "gridColor": "#7aa3ef",
        "pointsInLine": 3,
        "origin": origin,
        "spacing": spacing,
        "renderAsSvg": false,
        "haloColor": "rgba(0,0,0,0)",
        "labelColor": "rgba(0,0,0,0)",
        "indent": 0,
        "haloRadius": 0,
        "font": {
          "name": [
            "Liberation Sans",
            "Helvetica",
            "Nimbus Sans L",
            "Liberation Sans",
            "FreeSans",
            "Sans-serif"
          ],
          "size": 8,
          "style": "BOLD"
        }
      };
      layerGridForMapDef1 = [layers1];
    } else {
      layerGridForMapDef1 = [];
    }

    // calculate coordinates layer
    if (state.coordinatesFrame === 'active') {
      let layers2 = {
        "labelProjection": labelProjection,
        "type": "grid",
        "gridType": "LINES",
        "style": {
          "version": "2",
          "*": {
            "symbolizers": [
              {
                "type": "line",
                "strokeColor": "white",
                "strokeOpacity": 1,
                "strokeWidth": strokeWidthLabel,
                "strokeLinecap": "round",
                "strokeDashstyle": "0.1 100000"
              }
            ]
          }
        },
        "gridColor": "black",
        "pointsInLine": 3,
        "origin": origin,
        "spacing": spacingMap2,
        "rotateLabels": false,
        "renderAsSvg": false,
        "haloColor": "white",
        "labelColor": "#009FE3",
        "unitFormat": "",
        "valueFormat": "#######",
        "indent": indent,
        "horizontalYOffset": horizontalYOffset,
        "verticalXOffset": verticalXOffset,
        "haloRadius": haloradius,
        "font": {
          "name": ["Swz721ti"],
          "size": fontsize,
          "style": "PLAIN"
        }
      };

      let layers5 = {
        "labelProjection": labelProjection,
        "type": "grid",
        "gridType": "LINES",
        "style": {
          "version": "2",
          "*": {
            "symbolizers": [
              {
                "type": "line",
                "strokeColor": "white",
                "strokeOpacity": 1,
                "strokeWidth": strokeWidthLabel,
                "strokeLinecap": "round",
                "strokeDashstyle": "0.1 100000"
              }
            ]
          }
        },
        "gridColor": "black",
        "pointsInLine": 3,
        "origin": origin,
        "spacing": spacingMap5,
        "rotateLabels": false,
        "renderAsSvg": false,
        "haloColor": "white",
        "labelColor": "#009FE3",
        "unitFormat": "",
        "valueFormat": "#######",
        "indent": indent,
        "horizontalYOffset": horizontalYOffset,
        "verticalXOffset": verticalXOffset,
        "haloRadius": haloradius,
        "font": {
          "name": ["Swz721ti"],
          "size": fontsize,
          "style": "PLAIN"
        }
      };

      layerGridForMapDef2 = [layers2];
      layerGridForMapDef5 = [layers5];

    } else {
      layerGridForMapDef2 = [];
      layerGridForMapDef5 = [];
    }

    let expectedSize;
    if(producto === 'Elaborado'){ //Mapa Elaborado
      expectedSize = properties.LAND_OR_PORT;
    } else if (producto === 'Foto' || (producto === 'Poster' && !state.posterLegend)){ //Mapa Foto o Mapa Poster sin leyenda
      if(state.orientation === 'Paisaje'){
        expectedSize = properties.FO_OR_POST_SLEY_LAND;
      } else {
        expectedSize = properties.FO_OR_POST_SLEY_PORT;
      }
    } else if (state.posterLegend) { //Mapa Poster con Leyenda
      if(state.orientation === 'Paisaje'){
        expectedSize = properties.POST_CLEY_LAND;
      } else {
        expectedSize = properties.POST_CLEY_PORT;
      }
    } else {
      expectedSize = properties.LAND_OR_PORT;
      console.warn("DefaultProductTypeError for defined Legend");
    }

    if (state.coordinatesFrame === "active" && state.gridFrame !== "active") {
      let strokeLinecap6 = lengthSideLines + " " + expectedSize.width;
      let strokeLinecap7 = lengthSideLines + " " + expectedSize.height;
      let layerMarks6 = {
        "type": "grid",
        "gridType": "LINES",
        "style": {
          "version": "2",
          "*": {
            "symbolizers": [
              {
                "type": "line",
                "strokeColor": "#009FE3",
                "strokeOpacity": 1,
                "strokeWidth": strokeWidth,
                "strokeLinecap": "round",
                "strokeDashstyle": strokeLinecap6
              }
            ]
          }
        },
        "gridColor": "#7aa3ef",
        "pointsInLine": 3,
        "origin": origin,
        "spacing": spacingMap2,
        "renderAsSvg": false,
        "haloColor": "rgba(0,0,0,0)",
        "labelColor": "rgba(0,0,0,0)",
        "indent": 0,
        "haloRadius": 0,
        "font": {
          "name": [
            "Liberation Sans",
            "Helvetica",
            "Nimbus Sans L",
            "FreeSans",
            "Sans-serif"
          ],
          "size": 8,
          "style": "BOLD"
        }
      };

      let layerMarks7 = {
        "type": "grid",
        "gridType": "LINES",
        "style": {
          "version": "2",
          "*": {
            "symbolizers": [
              {
                "type": "line",
                "strokeColor": "#009FE3",
                "strokeOpacity": 1,
                "strokeWidth": strokeWidth,
                "strokeLinecap": "round",
                "strokeDashstyle": strokeLinecap7
              }
            ]
          }
        },
        "gridColor": "#7aa3ef",
        "pointsInLine": 3,
        "origin": origin,
        "spacing": spacingMap5,
        "renderAsSvg": false,
        "haloColor": "rgba(0,0,0,0)",
        "labelColor": "rgba(0,0,0,0)",
        "indent": 0,
        "haloRadius": 0,
        "font": {
          "name": [
            "Liberation Sans",
            "Helvetica",
            "Nimbus Sans L",
            "Liberation Sans",
            "FreeSans",
            "Sans-serif"
          ],
          "size": 8,
          "style": "BOLD"
        }
      };
      layerGridForMapDef6 = [layerMarks6];
      layerGridForMapDef7 = [layerMarks7];
    } else {
      layerGridForMapDef6 = [];
      layerGridForMapDef7 = [];
    }

    // ----------------------------------------------------------------------
    let layersDef1;

    if (state.gridFrame === "active") {
      layersDef1 = layerGridForMapDef1;
      if (jsonEstilosPDF.length > 0) {
        jsonEstilosPDF.forEach((layerDibujo) => {
          layerDibujo.opacity = 1;
          layersDef1.push(layerDibujo);
        });
      }
      for (let i = 0; i < layersSheets.length; i++) {
        layersDef1.push(layersSheets[i]);
      }
    } else {
      if (state.isSimple === true) {
        layersDef1 = layersSheets
      } else {
        if (jsonEstilosPDF.length > 0) {
          layersDef1 = [];
          jsonEstilosPDF.forEach((layerDibujo) => {
            layerDibujo.opacity = 1;
            layersDef1.push(layerDibujo);
          });
          for (let i = 0; i < layersSheets.length; i++) {
            layersDef1.push(layersSheets[i]);
          }
        } else {
          layersDef1 = layersSheets;
        }
      }
    }

    const dibujos = [];
    if (jsonEstilosImage.length > 0) {
      jsonEstilosImage.forEach((layerDibujo) => {
        layerDibujo.opacity = 1;
        dibujos.push(layerDibujo);
        //layerGridForMapDef2.push(layerDibujo);
      });

      layersDef1 = dibujos.concat(layersDef1);
    }

    if (producto === 'Foto' && properties.PNOA_MODE !== 'LOCAL') {//if (state.active > 7 && properties.PNOA_MODE !== 'LOCAL') {
      //Por el Cambio de las dimensiones del mapa a un height y width mayores, se tiene que ajustar el Bbox para que sean del mismo tamaño que antes de este update de Templates
      let absX = Math.abs(this.insideCoordinates[0][0] - this.insideCoordinates[0][2]), absY = Math.abs(this.insideCoordinates[0][1] - this.insideCoordinates[0][3]), varW = 0, varH = 0, paraOperarX, paraOperarY;

      if(state.orientation === 'Paisaje'){//layout = 'poster';
        varW = 0.0429887410440122;//(2038/1954)-1 //NEW width: 2038  //OLD width: 1954
        varH = 0.069364161849711;//(1295/1211)-1  //NEW height: 1295 //OLD height: 1211
      }else if(state.orientation === 'Retrato'){//layout = 'posterPortrait';
        varW = 0.0438413361169103;//(2000/1916)-1 //NEW width: 2000  //OLD width: 1916
        varH = 0.0635881907645723;//(1405/1321)-1 //NEW height: 1405 //OLD height: 1321
      }

      paraOperarX = (varW * absX)/2;
      paraOperarY = (varH * absY)/2;
      this.insideCoordinates[0][0] = this.insideCoordinates[0][0] - paraOperarX;
      this.insideCoordinates[0][1] = this.insideCoordinates[0][1] - paraOperarY;
      this.insideCoordinates[0][2] = this.insideCoordinates[0][2] + paraOperarX;
      this.insideCoordinates[0][3] = this.insideCoordinates[0][3] + paraOperarY;
      //Por el Cambio de las dimensiones

      const GMCtransformation = ol.proj.transform([this.insideCoordinates[0][0], this.insideCoordinates[0][1]], 'EPSG:3857', 'EPSG:3857')
      GMCtransformation.push(...ol.proj.transform([this.insideCoordinates[0][2], this.insideCoordinates[0][3]], 'EPSG:3857', 'EPSG:3857'))
      mapDef1 = {
        "bbox": GMCtransformation,
        "dpi": dpi,
        "layers": layersDef1,
        "projection": "EPSG:3857",
        "rotation": rotation,
      };
      // GRIDS
      mapDef2 = {
        "bbox": GMCtransformation,
        "dpi": dpi,
        "layers": layerGridForMapDef2,
        "projection": "EPSG:3857",
        "rotation": rotation,
      };

      mapDef5 = {
        "bbox": GMCtransformation,
        "dpi": dpi,
        "layers": layerGridForMapDef5,
        "projection": "EPSG:3857",
        "rotation": rotation,
      };

      mapDef6 = {
        "bbox": GMCtransformation,
        "dpi": dpi,
        "layers": layerGridForMapDef6,
        "projection": "EPSG:3857",
        "rotation": rotation,
      };

      mapDef7 = {
        "bbox": GMCtransformation,
        "dpi": dpi,
        "layers": layerGridForMapDef7,
        "projection": "EPSG:3857",
        "rotation": rotation,
      };
    } else {
      mapDef1 = {
        "center": scaledCenter,
        "dpi": dpi,
        "layers": layersDef1,
        "projection": "EPSG:" + projection,
        "rotation": rotation,
        "scale": scaleTransformed,
      };
      // GRIDS
      mapDef2 = {
        "center": scaledCenter,
        "dpi": dpi,
        "layers": layerGridForMapDef2,
        "projection": "EPSG:" + projection,
        "rotation": rotation,
        "scale": scaleTransformed,
      };

      mapDef5 = {
        "center": scaledCenter,
        "dpi": dpi,
        "layers": layerGridForMapDef5,
        "projection": "EPSG:" + projection,
        "rotation": rotation,
        "scale": scaleTransformed,
      };

      mapDef6 = {
        "center": scaledCenter,
        "dpi": dpi,
        "layers": layerGridForMapDef6,
        "projection": "EPSG:" + projection,
        "rotation": rotation,
        "scale": scaleTransformed,
      };

      mapDef7 = {
        "center": scaledCenter,
        "dpi": dpi,
        "layers": layerGridForMapDef7,
        "projection": "EPSG:" + projection,
        "rotation": rotation,
        "scale": scaleTransformed,
      };
    }

    let geoJsonDef3 = {
      "type": "FeatureCollection",
      "features": [
        {
          "type": "Feature",
          "id": "mapaUbicacionEspana",
          "geometry": {
            "type": "Point",
            "coordinates": scaledCenterMapDef3
          },
          "properties": {
            "name": "draw-00",
            "size": 24,
            "color": "#ffffff",
          }
        }
      ]
    }

    let styleDef3 = {
      "version": "2",
      "[name = 'draw-00']": {
        "symbolizers": [
          {
            "type": "point",
            "fillColor": "#ffffff",
            "fillOpacity": 1,
            "strokeColor": "red",
            "strokeOpacity": 1,
            "strokeWidth": strokeWidthLabel,
            "strokeLinecap": "round",
            "rotation": "0",
            "pointRadius": pointRadius,
          }
        ]
      }
    }

    let layersDef3 = [
      {
        "type": "geojson",
        "geoJson": geoJsonDef3,
        "style": styleDef3,
      },
      layerTiffSpain,
    ];

    mapDef3 = {
      "center": centerMapDef3,
      "rotation": rotation2,//para portrait nuevo
      "layers": layersDef3,
      "scale": scaleMapDef3,
      "projection": "EPSG:25830",
      "dpi": 200,
    }

    let geoJsonDef4 = {
      "type": "FeatureCollection",
      "features": [
        {
          "type": "Feature",
          "id": "mapaUbicacionCanarias",
          "geometry": {
            "type": "Point",
            "coordinates": scaledCenterMapDef4,
          },
          "properties": {
            "name": "draw-00",
            "size": 24,
            "color": "#ffffff",
          },
        },
      ],
    };

    let styleDef4 = {
      "version": "2",
      "[name = 'draw-00']": {
        "symbolizers": [
          {
            "type": "point",
            "fillColor": "#ffffff",
            "fillOpacity": 1,
            "strokeColor": "red",
            "strokeOpacity": 1,
            "strokeWidth": strokeWidthLabel,
            "strokeLinecap": "round",
            "rotation": "0",
            "pointRadius": pointRadius
          },
        ],
      },
    };

    let layersDef4 = [
      {
        "type": "geojson",
        "geoJson": geoJsonDef4,
        "style": styleDef4,
      },
      layerTiffCanaryIslands,
    ]

    mapDef4 = {
      "center": [
        418456.994329, 3135842.013305
      ],
      "rotation": rotation2,//para portrait nuevo
      "layers": layersDef4,
      "scale": scaleMapDef4,
      "projection": "EPSG:25828",
      "dpi": 200,
    };

    let attributes;
    if (producto === 'Elaborado'){//if (state.active < 6){
      attributes = {
        "delta": delta,
        "omega": omega,
        "mathsDataCenter": undefined,
        "idPedido": undefined,
        "arrow": imgArrow,
        "circulo1": imgcircle1,
        "circulo2": imgcircle2,
        "circulo3": imgcircle3,
        "circulo4": imgcircle4,
        "gradient": gradient,
        "titleQR": imgTitleQR,
        "titleBack": imgTitleMACFront,
        "crsText": crsText,
        "mainImg": mainImg,
        "mainImgBack": mainImgBack,
        "logoMAC": logoMapaALaCarta,
        "QRcode": qrcode,
        "author": author,
        "colorFront": colorFront,
        "imgFront": imageFront,
        "imgFrontCustom": imageFrontCustom,
        "currentsSigns1": legend[0],
        "currentsSigns2": legend[1],
        "currentsSigns3": legend[2],
        "currentsSignsTextEnglish": currentsSignsTextEnglish,
        "currentsSignsText": currentsSignsText,
        "populationCore": legend[3],
        "populationCoreText": populationCoreText,
        "populationCoreTextEnglish": populationCoreTextEnglish,
        "landUse": legend[4],
        "landUseText": landUseText,
        "landUseTextEnglish": landUseTextEnglish,
        "logoBot": logo_cover,
        "logoTop": logo_map,
        "logoMACTop": logoMapaALaCartaCorner,
        "mapDef1": mapDef1,
        "mapDef2": mapDef2,
        "mapDef5": mapDef5,
        "mapDef3": mapDef3,
        "mapDef4": mapDef4,
        "mapDef6": mapDef6,
        "mapDef7": mapDef7,
        "mareografo": undefined,
        "scale": scale,
        "scaleCm": scaleCm,
        "scaleImg": scaleImg,
        "subtitle": subtitle,
        "title": title,
        "xCoordBotLeft": xCoordBotLeft,
        "xCoordBotRight": xCoordBotRight,
        "xCoordTopLeft": xCoordTopLeft,
        "xCoordTopRight": xCoordTopRight,
        "yCoordBotLeft": yCoordBotLeft,
        "yCoordBotRight": yCoordBotRight,
        "yCoordTopLeft": yCoordTopLeft,
        "yCoordTopRight": yCoordTopRight,
        "agradecimientos": agradecimientos,
        "creditosMapa": creditosMapa,
        "backgroundMar": state.backgroundMar,
      }
    } else {
      if(state.posterLegend){
        attributes = {
          "logoTop": logo_map,
          "logoMACTop": logoMapaALaCartaCorner,
          "mapDef1": mapDef1,
          "mapDef2": mapDef2,
          "mapDef5": mapDef5,
          "mapDef6": mapDef6,
          "mapDef7": mapDef7,
          "mathsDataCenter" : undefined,
          "agradecimientos": agradecimientos,
          "subtitle": subtitle,
          "title": title,
          "xCoordBotLeft": xCoordBotLeft,
          "xCoordBotRight": xCoordBotRight,
          "xCoordTopLeft": xCoordTopLeft,
          "xCoordTopRight": xCoordTopRight,
          "yCoordBotLeft": yCoordBotLeft,
          "yCoordBotRight": yCoordBotRight,
          "yCoordTopLeft": yCoordTopLeft,
          "yCoordTopRight": yCoordTopRight,

          "crsText": crsText,
          "currentsSigns1": legend[0],
          "currentsSigns2": legend[1],
          "currentsSigns3": legend[2],
          "currentsSignsTextEnglish": currentsSignsTextEnglish,
          "currentsSignsText": currentsSignsText,
          "delta": delta,
          "omega": omega,
          "mareografo": undefined,
          "populationCore": legend[3],
          "populationCoreText": populationCoreText,
          "populationCoreTextEnglish": populationCoreTextEnglish,
          "scale": scale,
          "scaleImg": scaleImg,
          "landUse": legend[4],
          "landUseText": landUseText,
          "landUseTextEnglish": landUseTextEnglish,
          "backgroundMar": state.backgroundMar,
        }
      }else{
        attributes = {
          "logoTop": logo_map,
          "logoMACTop": logoMapaALaCartaCorner,
          "mapDef1": mapDef1,
          "mapDef2": mapDef2,
          "mapDef5": mapDef5,
          "mapDef6": mapDef6,
          "mapDef7": mapDef7,
          "mathsDataCenter" : crsText,
          "agradecimientos": agradecimientos,
          "subtitle": subtitle,
          "title": title,
          "xCoordBotLeft": xCoordBotLeft,
          "xCoordBotRight": xCoordBotRight,
          "xCoordTopLeft": xCoordTopLeft,
          "xCoordTopRight": xCoordTopRight,
          "yCoordBotLeft": yCoordBotLeft,
          "yCoordBotRight": yCoordBotRight,
          "yCoordTopLeft": yCoordTopLeft,
          "yCoordTopRight": yCoordTopRight,
          "backgroundMar": state.backgroundMar,
        }
      }
    }

    if ( layout === "poster_L" && (state.scale === "1:40.000" || state.scale === "1:50.000" || state.scale === "1:60.000")){
      layout= layout+"_HIGH";
    }

    if(((state.serImgC && state.serImgC[index].realCodigoBarras) || state.realCodigoBarras) && codigosLegales){//state.realCodigoBarras &&  Enviados en textoResponsabilidadOCodigosEspeciales
      layout= 'Special_'+layout;
      if(state.serImgC){
        attributes.codigoBarras = state.serImgC[index].realCodigoBarras.split('base64,')[1];
      }else{
        attributes.codigoBarras = state.realCodigoBarras.split('base64,')[1];
      }
      // Imagenes de logos concretos ESPECIALES
      if(producto === 'Elaborado'){
        let auxLogo = attributes.logoMAC;
        let splitLogo = auxLogo.split('/');
        splitLogo[splitLogo.length-1] = "M_"+splitLogo[splitLogo.length-1];
        auxLogo = splitLogo.join('/')
        attributes.logoMAC = auxLogo;
      }
      let auxLogo = attributes.logoMACTop;
      let splitLogo = auxLogo.split('/');
      splitLogo[splitLogo.length-1] = ((producto === 'Foto')?"I_":"M_")+splitLogo[splitLogo.length-1];
      auxLogo = splitLogo.join('/')
      attributes.logoMACTop = auxLogo;
    }

    attributes.TopLeftLegend = oneTransparentPixel;//Sufre error si no se envia ningun elemento de imagen
    attributes.TopRightLegend = oneTransparentPixel;
    attributes.BottomLeftLegend = oneTransparentPixel;
    attributes.BottomRightLegend = oneTransparentPixel;
    if(state.definedLegend){//Leyend corner images
      let auxPromise = new Promise((success, fail)=>{
        let imgTEST = document.createElement('img')
        imgTEST.src = "data:image/svg+xml;charset=utf-8,"+encodeURIComponent(state.definedLegend.svg);// .replaceAll('#','%23') usar # causa error en lectura de imagen svg
        imgTEST.onload = () => {
          const scaleQuality = 5; // default 5 in web, Should never have decimals "LegendImageTransformBase"
          let oc = document.createElement('canvas');
          let auxCalcWidth = imgTEST.width*scaleQuality;
          let auxCalcHeight = imgTEST.height*scaleQuality;
          oc.height = (scaleQuality*expectedSize.height);
          if (rotation === 0){
            oc.width = auxCalcWidth;
            let octx = oc.getContext('2d');
            if (state.definedLegend.type === "BottomLeftLegend" || state.definedLegend.type === "BottomRightLegend") {
              octx.drawImage(imgTEST, 0, (scaleQuality*expectedSize.height)-auxCalcHeight, auxCalcWidth, auxCalcHeight);
            } else { // "TopLeftLegend" or "TopRightLegend"
              octx.drawImage(imgTEST, 0, 0, auxCalcWidth, auxCalcHeight);
            }
          } else { //rotation === 90
            oc.width = auxCalcHeight;
            let octx = oc.getContext('2d');
            octx.translate(auxCalcHeight / 2, auxCalcWidth / 2);
            octx.rotate(Math.PI / 2);
            octx.translate(-auxCalcWidth / 2, -auxCalcHeight / 2);
            if (state.definedLegend.type === "TopLeftLegend" || state.definedLegend.type === "BottomLeftLegend") {
              octx.drawImage(imgTEST, 0, 0, auxCalcWidth, auxCalcHeight);
            } else { // "TopRightLegend" or "BottomRightLegend"
              octx.drawImage(imgTEST, (scaleQuality*expectedSize.height)-auxCalcWidth, 0, auxCalcWidth, auxCalcHeight);
            }
          }
          let result = oc.toDataURL("image/png", 1);
          if(result.length>16){
            success(result.split(',')[1]);
          } else {
            fail("Base64 PNG no obtenido");
          }
        };
      });
      auxPromise.then((resultPNG)=>{
        attributes[state.definedLegend.type] = resultPNG;
        //if(rotation===90){let auxTempMemorizar=attributes.BottomLeftLegend;attributes.BottomLeftLegend=attributes.BottomRightLegend;attributes.BottomRightLegend=attributes.TopRightLegend;attributes.TopRightLegend=attributes.TopLeftLegend;attributes.TopLeftLegend=auxTempMemorizar;}//if clockwise rotation not posible
      }).catch((error)=>{
        console.warn("Error al aplicar Leyenda:",error);
      });
    }

    result = {
      "attributes": attributes,
      "layout": layout
    }

    return result;
    });

    if(preparedResult.length === 1){
      return preparedResult[0];
    }else{
      return preparedResult;
    }
  }

  handleCloseWizardWarning = () => {
    this.setState({showAlertModalWarning: false, showWarningCheckboxForMAR: false});
  }

  handleCloseWizardError = () => {
    this.setState({showAlertModalError: false, controlModal: 0});
  }

  // convert coordinates to DMS
  converterDecimalToDMS(coordinate) {
    const splittedCoord = coordinate.toString().split('.');
    //Degrees
    let res = splittedCoord[0] + "º ";
    //Minutes
    let aux = ('0.' + splittedCoord[1]) * 60;
    if(isNaN(aux)){
      aux = ['00'];
    } else {
      aux = aux.toString().split(".");
      if (aux[0].length<2 ) {//aux[0] === "0" || aux[0] === "1" || aux[0] === "2" || aux[0] === "3" || aux[0] === "4" || aux[0] === "5" || aux[0] === "6" || aux[0] === "7" || aux[0] === "8" || aux[0] === "9"
        aux[0] = "0" + aux[0];
      }
    }
    res = res + aux[0] + "' ";
    //Seconds
    aux = ('0.' + aux[1]) * 60;
    if(isNaN(aux)){
      aux = '00';
    } else {
      aux = aux.toString().split(".");
      if (aux[0].length<2 ) {//aux[0] === "0" || aux[0] === "1" || aux[0] === "2" || aux[0] === "3" || aux[0] === "4" || aux[0] === "5" || aux[0] === "6" || aux[0] === "7" || aux[0] === "8" || aux[0] === "9"
        aux = "0" + aux[0] + (aux[1]? "." + aux[1]: '');
      } else {
        aux = aux.join('.');
      }
    }
    res = res + aux + "'' ";
    return res;//.replace(",", ".")
  }

  formatCornersCoordinatesMethod(coordinateConverted) {
    const degrees = coordinateConverted.split("º")[0].trim();

    const auxMinutes = coordinateConverted.split("º")[1].trim();
    const minutes = auxMinutes.split("'")[0].trim();

    const auxSeconds = auxMinutes.split("'")[1].trim();
    const seconds = auxSeconds.substring(0, 5).trim();

    return degrees + "º " + minutes + "' " + seconds + "''";
  }

  // calculate the origin point of the grid

  calculateOrigin(xy_center, labelProjection, spacing) {
    let centerUTM = ol.proj.transform([
      xy_center[0], xy_center[1]
    ], 'EPSG:3857', labelProjection);
    let moduloX = centerUTM[0] % spacing[0];
    let moduloY = centerUTM[1] % spacing[1];

    let difX = spacing[0] - moduloX;
    let difY = spacing[1] - moduloY;

    let originX = centerUTM[0] + difX;
    let originY = centerUTM[1] + difY;

    return [originX, originY];
  }

  getState() {
    return this.state;
  }

  setUpdateCart = (callback) => {
    this.setState({ callback: callback });
  }

  render() {

    // modal for centroidSheet empty

    return (
      <React.Fragment>
        <ShoppingCart setUpdateCart={this.setUpdateCart} />
        <ReactNotification />
        {
          parseInt(this.state.active) === 0
            ? <Step1 setModal={this.setModal} setParentState={this.setStateGlobal} parentState={this.state} location={this.props.location} setParentStateSteps={this.setStateGlobalSteps}></Step1>
            : null
        }
        {
          parseInt(this.state.active) === 1
            ? <Step2 setParentState={this.setStateGlobal} parentState={this.state} setParentStateSteps={this.setStateGlobalSteps}></Step2 >
            : null
        }
        {
          parseInt(this.state.active) === 2
            ? <Step3 parentState={this.state} setParentState={this.setStateGlobal} setParentStateSteps={this.setStateGlobalSteps} converterDecimalToDMS={this.converterDecimalToDMS} conversorStateToMapfish={this.conversorStateToMapfish} conversorPDF={this.conversorStateToMapfish(this.state, 'Elaborado')}></Step3>
            : null
        }
        {
          parseInt(this.state.active) === 3
            ? <Step4 parentState={this.state} setParentState={this.setStateGlobal} setParentStateSteps={this.setStateGlobalSteps} converterDecimalToDMS={this.converterDecimalToDMS} conversorStateToMapfish={this.conversorStateToMapfish}></Step4 >
            : null
        }
        {
          parseInt(this.state.active) === 4
            ? <Step1S setModal={this.setModal} parentState={this.state} location={this.props.location} setParentState={this.setStateGlobal} setParentStateSteps={this.setStateGlobalSteps} converterDecimalToDMS={this.converterDecimalToDMS} conversorStateToMapfish={this.conversorStateToMapfish}></Step1S>
            : null
        }
        {
          parseInt(this.state.active) === 5
            ? <Step2S parentState={this.state} setParentState={this.setStateGlobal} setParentStateSteps={this.setStateGlobalSteps} converterDecimalToDMS={this.converterDecimalToDMS} conversorStateToMapfish={this.conversorStateToMapfish} conversorPDF={this.conversorStateToMapfish(this.state, 'Elaborado')}></Step2S >
            : null
        }
        {
          parseInt(this.state.active) === 6
            ? <Step1P setModal={this.setModal} parentState={this.state} location={this.props.location} setParentState={this.setStateGlobal} setParentStateSteps={this.setStateGlobalSteps} converterDecimalToDMS={this.converterDecimalToDMS} conversorStateToMapfish={this.conversorStateToMapfish}></Step1P >
            : null
        }
        {
          parseInt(this.state.active) === 7
            ? <Step2P parentState={this.state} setParentState={this.setStateGlobal} setParentStateSteps={this.setStateGlobalSteps} converterDecimalToDMS={this.converterDecimalToDMS} conversorStateToMapfish={this.conversorStateToMapfish} conversorPDF={this.conversorStateToMapfish(this.state, 'Poster')}></Step2P >
            : null
        }
        {
          parseInt(this.state.active) === 8
            ? <Step1F setModal={this.setModal} parentState={this.state} location={this.props.location} setParentState={this.setStateGlobal} setParentStateSteps={this.setStateGlobalSteps} converterDecimalToDMS={this.converterDecimalToDMS} conversorStateToMapfish={this.conversorStateToMapfish}></Step1F >
            : null
        }
        {
          parseInt(this.state.active) === 9
            ? <Step2F parentState={this.state} setParentState={this.setStateGlobal} setParentStateSteps={this.setStateGlobalSteps} converterDecimalToDMS={this.converterDecimalToDMS} conversorStateToMapfish={this.conversorStateToMapfish} conversorPDF={this.conversorStateToMapfish(this.state, 'Foto')}></Step2F >
            : null
        }
        {
          parseInt(this.state.active) === 10
            ? <Step1SS setModal={this.setModal} setParentState={this.setStateGlobal} parentState={this.state} location={this.props.location} setParentStateSteps={this.setStateGlobalSteps}></Step1SS >
            : null
        }
        {
          parseInt(this.state.active) === 11
            ? <Step2SS setParentState={this.setStateGlobal} parentState={this.state} setParentStateSteps={this.setStateGlobalSteps}></Step2SS >
            : null
        }
        {
          parseInt(this.state.active) === 12
            ? <Step3SS parentState={this.state} setParentState={this.setStateGlobal} setParentStateSteps={this.setStateGlobalSteps} converterDecimalToDMS={this.converterDecimalToDMS} conversorStateToMapfish={this.conversorStateToMapfish} conversorPDF={this.conversorStateToMapfish(this.state, 'Serie')}></Step3SS >
            : null
        }

        <Dialog open={this.state.showAlertModalWarning} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
          <ThemeProvider theme={themeTitle}>
            <DialogTitle id="alert-dialog-title">{"Advertencia"}</DialogTitle>
          </ThemeProvider>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
            <Trans i18nKey="dialog.notEnoughGeographicInformation">
              Falta parte de la información geográfica de la zona. Es posible que su mapa tenga zonas blancas al imprimir.
            </Trans>
            </DialogContentText>
            <div className="applyBackground" style={{display:this.state.showWarningCheckboxForMAR?"block":"none"}}>
              <input id="background_state" type="checkbox" checked={this.state.backgroundMar !== "#FFFFFF"} onClick={this.toggleBackground.bind(this)} readOnly/>
              <label><Trans i18nKey="step1.background">Marque la casilla para rellenar con color del mar</Trans></label>
            </div>
          </DialogContent>
          <DialogActions>
            <ThemeProvider theme={theme}>
              <DialogButton size="small" variant="contained" color="primary" onClick={this.handleCloseWizardWarning}>
              <Trans i18nKey="dialog.accept">
                Aceptar
              </Trans>
              </DialogButton>
            </ThemeProvider>
          </DialogActions>
        </Dialog>

        <Dialog open={this.state.showAlertModalError} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
          <ThemeProvider theme={themeTitle}>
            <DialogTitle id="alert-dialog-title">{"Error"}</DialogTitle>
          </ThemeProvider>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
            <Trans i18nKey="dialog.noGeographicInformation2">
              El área seleccionada no contiene suficiente información geográfica. Por favor seleccione un área correspondiente a España (Península, Canarias y Baleares).
            </Trans>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <ThemeProvider theme={theme}>
              <DialogButton size="small" variant="contained" color="primary" onClick={this.handleCloseWizardError}>
              <Trans i18nKey="dialog.accept">
                Aceptar
              </Trans>
              </DialogButton>
            </ThemeProvider>
          </DialogActions>
        </Dialog>
      </React.Fragment>
    );
    }
  }

  export default DataForPrint;
